/// SHARED VARIABLES
/// (Ideally wrap these in an interface)
const { io } = require('./ioHandler');
const { reactRender } = require('./reactRender');
const replay = require('./replay');
const { incrementCounterValue, observeHistogramMetric } = require('./frontendStats');
const config = require('../config');

const DARK_MODE = false;

// default - can be changed by server
var GAME_CONST = {
  MAX_BULLETS: 10,
  SHOOT_ROF: 500,
  BULLET_REGEN: 10 * 1000,
  BASE_BULLET_LIFETIME: 600,
  PLAYER_SPEED: 13.0, // smaller is faster
  BULLET_SPEED: 5.0, // smaller is faster
  INVIS_TIME: 7.5 * 1000,
  REVEAL_TIMER: 35 * 1000,
};

var isAiMode = false;
var aiLevel = 4; // 0 = beginner, 1 = easy, 2 = medium, 3 = hard, 4 = nightmare


var w = 640;
var h = 480;

var timeNow = 0;
var lastTime = new Date().getTime();
var gameStartTime = 0;
var gameNowTime = 0;
var matchResult, roundResult;
var currentGameId;

var canvas;
var ctx;
var elemLeft;
var elemTop;

var previouslyPressedKeys = {}
var currentlyPressedKeys = {};

function handleKeyDown(event) {
  currentlyPressedKeys[event.keyCode] = true;
}

function handleKeyUp(event) {
  currentlyPressedKeys[event.keyCode] = false;
}

document.addEventListener('keydown', handleKeyDown, false);
document.addEventListener('keyup', handleKeyUp, false);

var gameObjects = [];
var newGameObjects = [];
var players = {};
var thePowerup = null;
var theBomb = null;
var isGameRanked = false;
var gameRankedBeginAlpha = 0.0;
var theInvisField = null;
var theScan = null;
var mines = {};
var theWalls = null;
var myId = 0;
var blackoutAlpha = 0.0;
var blackoutText = "";
var isShowingDeadView = false;
let afkWarningTimer = 0;

var numPlayers = 1;
var playerNames = [];

var myPlayer = null;
var myBullets = 10;
var myBulletRegenTime = 0;
var lastRevealTime = 0;
var revealAlpha = 0.0;

var gameDiv = null;

var mouseX = 0;
var mouseY = 0;

var upperPadding = 0;
var lowerPadding = 0;

var isTutorialMode = false;
var tutorialState = 0;
var tutorialDelay = 0;
var gameScale = 1;

var needToShowMessage = false;
var gameJoinCode = null;

function constructGameHTML() {

  if (gameDiv)
    return;

  gameDiv = document.createElement("div");
  gameDiv.className = 'container';

  var image = document.createElement('div');
  image.className = "background";

  canvas = document.createElement('canvas');
  canvas.className = "gameCanvas";

  canvas.width = Math.min(reactRender.MAX_WIDTH, window.innerWidth) - 2;
  canvas.height = Math.min(reactRender.MAX_HEIGHT, window.innerHeight) - 2;

  var scaledGameH = canvas.width * (h / w);
  if (canvas.height > scaledGameH) {
    upperPadding = lowerPadding = (canvas.height - scaledGameH) / 2;
  }

  var gameCanvasHeight = canvas.height - upperPadding - lowerPadding;
  gameScale = Math.min(gameCanvasHeight / h, canvas.width / w);

  ctx = canvas.getContext("2d");

  gameDiv.append(image);
  gameDiv.append(canvas);

  document.body.append(gameDiv);

  elemLeft = canvas.parentElement.offsetLeft;
  elemTop = canvas.parentElement.offsetTop;

  var clickFunction = function (event) {

    if (!myPlayer)
      return;

    afkWarningTimer = 0;

    var x = (event.pageX / gameScale - elemLeft);
    var y = (event.pageY / gameScale - elemTop - upperPadding);

    var mult = getBoundingScale(x, y);
    x = (x - myPlayer.x) / mult + myPlayer.x;
    y = (y - myPlayer.y) / mult + myPlayer.y;

    if (isTutorialMode)
      myPlayer.move(x, y);
    else
      io.emit("move", { x: x, y: y });
  }
  canvas.addEventListener('click', clickFunction, false);

  var mouseMove = function (event) {

    if (!myPlayer)
      return;

    var x = (event.pageX / gameScale - elemLeft);
    var y = (event.pageY / gameScale - elemTop - upperPadding);

    var mult = getBoundingScale(x, y);
    x = (x - myPlayer.x) / mult + myPlayer.x;
    y = (y - myPlayer.y) / mult + myPlayer.y;

    mouseX = x;
    mouseY = y;
  }
  canvas.onmousemove = mouseMove;

  var rightClick = function (event) {

    if (event.preventDefault)
      event.preventDefault();

    if (!myPlayer)
      return;

    var x = (event.pageX / gameScale - elemLeft);
    var y = (event.pageY / gameScale - elemTop - upperPadding);

    var mult = getBoundingScale(x, y);
    mouseX = (x - myPlayer.x) / mult + myPlayer.x;
    mouseY = (y - myPlayer.y) / mult + myPlayer.y;

    shoot(mouseX, mouseY);
  };
  canvas.oncontextmenu = rightClick

  window.addEventListener("message", function (event) {
    if (event.data.type == 0)
      clickFunction(event.data);
    else if (event.data.type == 1)
      rightClick(event.data);
    else if (event.data.type == 2)
      mouseMove(event.data);
    else if (event.data.type == 3)
      handleKeyDown(event.data);
    else if (event.data.type == 4)
      handleKeyUp(event.data);

  }, false);
}

var lastShootTime = 0;
function shoot(mouseX, mouseY) {
  if (isTutorialMode)
    myPlayer.shoot(mouseX, mouseY);
  else if (timeNow > lastShootTime + 200) {
    afkWarningTimer = 0;
    io.emit("shoot", { x: mouseX, y: mouseY });
    lastShootTime = timeNow;
  }
}

function getBoundingScale(x, y) {

  var px = myPlayer.x;
  var py = myPlayer.y;
  var dx = x - px;
  var dy = y - py;

  var mult1 = 1;
  if (x < 0) {
    mult1 = -dx / px;
  }
  else if (x > w) {
    mult1 = dx / (w - px);
  }

  var mult2 = 1;
  if (y < 0) {
    mult2 = -dy / py;
  }
  else if (y > h) {
    mult2 = dy / (h - py);
  }

  return Math.max(mult1, mult2);
}

function initTutorial() {

  var key = 1;
  var thePlayer = new Player(w / 2, h / 2);
  thePlayer.id = key;
  maxBullets = 10;
  myBullets = 10;

  players[key] = thePlayer;
  addGameObj(thePlayer);
  myPlayer = thePlayer;
  myId = 1;

  tutorialState = 0;
  tutorialDelay = 0;

  myPlayer = thePlayer;

  for (var i = 0; i < 5; i++) {
    var s = Math.random() * 30;
    var x = thePlayer.x - 40 + Math.random() * 80;
    var y = thePlayer.y - 40 + Math.random() * 80;
    addGameObj(new Box(x - s / 2, y - s / 2, s, s, 5 * Math.random(), true));
  }

  addGameObj(new Wave(x, y, "255, 0, 0"));

  for (var i = 0; i < 30; i++) {
    addGameObj(new Bit(thePlayer.x - 4 + 8 * Math.random(), thePlayer.y - 4 + 8 * Math.random(), "255, 0, 0"));
  }

  makeBoxes();
}

var mainMenuFunction;
var findGameFunction;
var findGameText;
var returnToLobbyInsteadOfMainMenuFromReplay;
var ioSetup = false;
var numFudgeJumps = 0;
var sumFudgeDist = 0;
var noBulletsAlpha = 0;

function resetGlobalVars() {

  needToShowMessage = true;
  playerNameCount = 0;
  if (threatIndex)
    threatIndex = [];
  aiNewAlert = -1000;
}

var rankedGameInBackground = false;

function initGame(tutorialMode, mainMenu, findGame, inFindGameText = undefined, isRankedGameInBackground = false) {
  reactRender.nothing();
  isShowingDeadView = false;
  isGameRanked = false;
  rankedGameInBackground = isRankedGameInBackground;

  myKiller = "";
  numFudgeJumps = 0;
  sumFudgeDist = 0;
  needToShowMessage = true;


  constructGameHTML();

  var sound = document.getElementById("ready");
  sound.volume = 0.55;
  sound.play();

  // if (window.history.replaceState)
  //  window.history.replaceState({ }, "", "/");

  returnToLobbyInsteadOfMainMenuFromReplay = inFindGameText ? true : false;
  findGameText = inFindGameText ? inFindGameText : "Find Game";

  if (tutorialMode) {
    reactRender.tutorialOverlay(() => { endGame(); mainMenu(); incrementCounterValue("did_finish_tutorial", "no"); });
    isShowingDeadView = false;
  }

  playerNames = [];
  thePortal = null;
  mainMenuFunction = mainMenu;
  findGameFunction = findGame;

  textBuffer.length = 0;
  blackoutAlpha = 0.0;
  isTutorialMode = tutorialMode;

  gameObjects = [];
  newGameObjects = [];
  players = {};

  thePowerup = null;
  theBomb = null;
  theInvisField = null;
  theScan = null;
  mines = {};
  myPowerup = 0;
  theWalls = null;
  gameJoinCode = undefined;

  matchResult = null;
  roundResult = null;
  matchResultData = null;

  tutorialState = 10000;

  resetGlobalVars();

  tutorialDelay = 0;

  if (isTutorialMode)
    initTutorial();


  gameStartTime = new Date().getTime();


  if (!isTutorialMode && !ioSetup) {
    ioSetup = true;

    // register io events
    io.on('gamePing', handleGamePing);
    io.on('init', handleInit);
    io.on('debug', handleDebugData);
    io.on('respawn', handleRespawn);
    io.on('respawnCount', handleRespawnCount);
    io.on('names', handleNames);
    io.on('joined', handleJoined);
    io.on('m', handleMove);
    io.on('poisoned', handlePoisoned);
    io.on('blackout', handleBlackout);
    io.on('reveal', handleReveal);
    io.on('numPlayers', handleNumPlayers);
    io.on('kills', handleKills);
    io.on('shoot', handleShoot);
    io.on('dshoot', handleDshoot);
    io.on('new', handleNew);
    io.on('die', handleDie);
    io.on('playerDisconnect', handleDisconnect);
    io.on("alertFoundGame", handleAlertFoundGame);

    io.on('powerup', handlePowerup);
    io.on('powerupwarn', handlePowerupWarn);
    io.on('bomb', handleBomb);
    io.on('invisField', handleInvisField);
    io.on('scan', handleScan);
    io.on('mine', handleMine);
    io.on('dmine', handleDMine);
    io.on('walls', handleWalls);
    io.on('powerdest', handlePowerDest);
    io.on('powerget', handlePowerGet);
    io.on('invis', handleInvis);
    io.on('tp', handleTp);
    io.on('fast', handleFast);
    io.on('rapidFire', handleRapidFire);

    io.on('shield', handleShield);
    io.on('dshield', handleDShield);

    io.on('matchResult', handleMatchResult);
    io.on('roundResult', handleRoundResult);
    io.on('replayReady', handleReplayReady);

    playersDisplayed = 0;
    displayingPlayers = true;

    io.on('invisDone', function (msg) {

      myId = msg;

      if (myPlayer && !myPlayer.toKill) {

        delete players[myPlayer.id];

        myPlayer.id = msg;
        players[myPlayer.id] = myPlayer;
        myPlayer.invis = false;

      }

      myPlayer = players[myId];
    });

    io.on('bullets', function (msg) {
      myBullets = msg;
      myBulletRegenTime = timeNow;
    });

    var postedNoBullets = false;
    io.on('nobullets', function (msg) {
      myBullets = 0;
      noBulletsAlpha = 1.0;

      if (!postedNoBullets) {
        addFeedText("No Bullets!!!");
        postedNoBullets = true;
      }
    });

    lastPlayerDisplayedTime = timeNow + 2000;
  }

  drawGrid();
}

function drawRankedGameBegin(dTime) {
  if (gameRankedBeginAlpha > 0) {

    gameRankedBeginAlpha -= dTime * 0.0005;

    if (gameRankedBeginAlpha > 0) {

      if (playerNames && playerNames[0] && playerNames[1]) {
        reactRender.rankedBegin(gameRankedBeginAlpha, playerNames[0].name, playerNames[1].name, playerNames[0].rank, playerNames[1].rank);
        isShowingDeadView = false;
      }

    } else {
      reactRender.nothing();
      isShowingDeadView = false;
    }
  }
}

function makeBoxes() {
  var s = 64;
  var alpha = 1.5;
  for (var x = 0; x < w; x += s) {
    for (var y = 0; y < w; y += s) {
      {
        var box = new Box(x, y, s * 0.9, s * 0.9, alpha, true);
        addGameObj(box);
      }
      {
        var x2 = x;
        var y2 = y;
        if (Math.random() > 0.5) {
          x2 += s * 0.5;
          y2 += s * 0.5;
        }
        var box = new Box(x2, y2, s * 0.4, s * 0.4, alpha, false);
        addGameObj(box);
      }
      alpha += 0.05;
    }
  }

  if (!isTutorialMode) {

    var x = w / 2;
    var y = h / 2;
    if (myPlayer) {
      x = myPlayer.x;
      y = myPlayer.y;
    }

    for (var i = 0; i < 30; i++) {
      addGameObj(new Bit(x - 4 + 8 * Math.random(), y - 4 + 8 * Math.random(), "255, 0 ,0"));

    }
    addGameObj(new Wave(x, y, "255, 0, 0"));
  }
}

function endGame() {

  if (!isTutorialMode) {
    ioSetup = false;
    io.off('init');
    io.off("alertFoundGame");
    io.off('m');
    io.off('respawn');
    io.off('poisoned')
    io.off('respawnCount');
    io.off('debug');
    io.off('names');
    io.off('reveal');
    io.off('numPlayers');
    io.off('kills');
    io.off('shoot');
    io.off('dshoot');
    io.off('new');
    io.off('die');
    io.off('playerDisconnect');
    io.off('fast');
    io.off('rapidFire')
    io.off('powerup');
    io.off('powerupwarn');
    io.off('bomb');
    io.off('invisField');
    io.off('scan');
    io.off('mine');
    io.off('dmine');
    io.off('walls');
    io.off('powerdest');
    io.off('powerget');
    io.off('invis');
    io.off('tp');
    io.off('shield');
    io.off('dshield');
    io.off('replayReady')

    io.off('matchResult');
    io.off('roundResult');

    io.off('invisDone');
    io.off('bullets');
    io.off('nobullets');
  }

  myBullets = 10;
  myBulletRegenTime = 0;
  if (gameDiv) {
    document.body.removeChild(gameDiv);
    gameDiv = null;
  }
}

module.exports = {
  initGame,
}

var cellSize = 32;
var coolBackground = [];
for (var x = 0; x < w; x += cellSize) {
  var cool = [];
  for (var y = 0; y < h; y += cellSize) {
    cool.push(x * 0.01);
  }
  coolBackground.push(cool);
}

var squareList = [];

for (var i = 0; i < 50; i++) {

  var square = {};
  square.size = Math.random() * 100 + 50;
  square.x = Math.random() * w - square.size / 2;
  square.y = Math.random() * h - square.size / 2;
  square.alpha = Math.random() * Math.abs(w / 2 - square.x) / w * 2 * Math.abs(h / 2 - square.y) / h * 2;
  if (square.alpha > 0.25)
    squareList.push(square);
}


function updateCells(x1, y1, w, h) {

  var x2 = Math.floor((x1 + w) / cellSize);
  var y2 = Math.ceil((y1 + h) / cellSize);
  x1 = Math.floor(x1 / cellSize);
  y1 = Math.ceil(y1 / cellSize);

  if (x1 < 0)
    x1 = 0;
  if (x2 > coolBackground.length)
    x2 = coolBackground.length;

  if (y1 < 0)
    y1 = 0;
  if (y2 > coolBackground[0].length)
    y2 = coolBackground[0].length;

  for (var x = x1; x <= x2; x++)
    for (var y = y1 - 1; y < y2; y++)
      coolBackground[x][y] = 1.0;
}

function drawCoolBackground(dTime) {

  var main = "black"
  var stroke = "black"

  ctx.strokeStyle = stroke;
  ctx.globalAlpha = 0.05;
  ctx.fillStyle = main;

  for (var i = 0; i < squareList.length; i++) {
    var square = squareList[i];
    ctx.beginPath();
    ctx.rect(square.x, square.y, square.size, square.size);

    ctx.globalAlpha = square.alpha * 0.03;
    ctx.lineWidth = 10;
    ctx.stroke();

    ctx.globalAlpha = square.alpha * 0.3;
    ctx.lineWidth = 1;
    ctx.stroke();
  }
  return;

  var buffer = 2;

  for (var x = 0; x < w; x += cellSize) {
    for (var y = 0; y < h; y += cellSize) {


      coolBackground[x / cellSize][y / cellSize] -= dTime * 0.001;

      var val = coolBackground[x / cellSize][y / cellSize];


      ctx.globalAlpha = 1.0;
      ctx.fillStyle = main;
      ctx.fillRect(x, y, cellSize - buffer, cellSize - buffer);

      ctx.strokeStyle = stroke;
      ctx.beginPath();
      ctx.rect(x, y, cellSize - buffer, cellSize - buffer);
      ctx.stroke();
    }
  }
}

var lineTime = 0;
function tutLines(dTime) {

  lineTime += dTime;
  if (lineTime > 300)
    lineTime -= 300;
  else
    return;


  var size = 800 * Math.random();
  var speed = -0.0025;
  var x = w * Math.random();
  var y = h * Math.random();
  var offset = 100 * Math.random();
  var color = "255, 0, 0";
  var alpha = 0.5;
  var alphaChange = 0.00005;

  var line = null;
  if (Math.random() > 0.75) {

    line = new Line(x - size / 2, offset, x + size / 2, offset, color, alpha, alphaChange);
    line.dy = speed;

  } else if (Math.random() > 0.66) {

    line = new Line(x - size / 2, h - offset, x + size / 2, h - offset, color, alpha, alphaChange);
    line.dy = -speed;

  } else if (Math.random() > 0.5) {

    line = new Line(offset, y - size / 2, offset, y + size / 2, color, alpha, alphaChange);
    line.dx = speed;

  } else {

    line = new Line(w - offset, y - size / 2, w - offset, y + size / 2, color, alpha, alphaChange);
    line.dx = -speed;
  }

  line.alphaMult = 0;
  //if (Object.keys(players).length < 2)
  //  line.useDepth = true;

  addGameObj(line);
}

function drawGrid() {

  if (!gameDiv)
    return;

  timeNow = new Date().getTime();
  if (myPlayer && numPlayers > 1)
    gameNowTime = timeNow;

  var dTime = timeNow - lastTime;

  if (dTime > 200) io.emit("reinit", true);

  if (dTime > 60)
    dTime = 60;

  drawRankedGameBegin(dTime);

  if (isTutorialMode || roundResult)
    tutLines(dTime);

  ctx.save();
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.scale(gameScale, gameScale);

  ctx.font = "16px Arial";
  ctx.textAlign = "left";
  ctx.fillStyle = "#999999";
  ctx.globalAlpha = 1.0;

  ctx.lineWidth = 1;
  ctx.translate(0, upperPadding);

  drawCoolBackground(dTime);

  for (var i = 0; i < gameObjects.length; i++) {
    var obj = gameObjects[i];
    if (!obj.toKill && obj.underUpdate)
      obj.underUpdate(dTime, ctx);
  }

  for (var i = 0; i < gameObjects.length; i++) {
    var obj = gameObjects[i];
    if (!obj.toKill)
      obj.update(dTime, ctx);
  }

  for (var i = 0; i < gameObjects.length; i++) {
    var obj = gameObjects[i];
    if (!obj.toKill && obj.overUpdate)
      obj.overUpdate(dTime, ctx);
  }

  for (var i = 0; i < gameObjects.length; i++) {
    var obj = gameObjects[i];
    if (obj.toKill)
      removeFromArray(obj, gameObjects);
  }

  for (var i = 0; i < newGameObjects.length; i++) {
    var obj = newGameObjects[i];
    gameObjects.unshift(obj);
  }
  newGameObjects = [];

  ctx.globalAlpha = 1.0;
  ctx.lineWidth = 1.0;
  ctx.strokeStyle = "#000000";
  drawWalls(0);

  ctx.globalAlpha = 0.4;
  drawWalls(1);
  drawWalls(-1);

  blackoutAlpha -= 0.001 * dTime;
  if (blackoutAlpha > 0) {

    ctx.globalAlpha = Math.min(1.0, blackoutAlpha);
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = "red";
    ctx.textAlign = "center";
    ctx.font = "16px Arial";
    ctx.fillText(blackoutText, w / 2, h / 2);
  }

  lastTime = timeNow;

  // upper UI
  ctx.setTransform(1, 0, 0, 1, 0, 0);

  ctx.fillStyle = "rgb(255, 254, 254)";
  ctx.globalAlpha = 1;

  if (upperPadding > 0)
    ctx.fillRect(0, 0, canvas.width, upperPadding);
  if (lowerPadding > 0)
    ctx.fillRect(0, canvas.height - lowerPadding, canvas.width, lowerPadding);

  ctx.fillStyle = "rgb(200, 200, 200)";
  if (upperPadding > 0)
    ctx.fillRect(0, upperPadding, canvas.width, 1);
  if (lowerPadding > 0)
    ctx.fillRect(0, canvas.height - lowerPadding, canvas.width, 1);
  ctx.fillRect(w * gameScale, upperPadding, 1, canvas.height - lowerPadding - upperPadding);

  ctx.globalAlpha = 1.0;
  ctx.font = "12px Arial";
  var y = 30;
  ctx.textAlign = "left";

  playerNames.forEach(playerNameAndId => {

    if (!playerNameAndId.dead) {
      ctx.fillStyle = "#FF0000";
      ctx.globalAlpha = 1.0;
    } else {
      ctx.fillStyle = "#444444";
      ctx.globalAlpha = 0.7;
    }

    const gameWins = maxWins;
    if (playerNameAndId.wins > 0)
      ctx.fillText(playerNameAndId.name + " (" + playerNameAndId.wins + "/" + gameWins + " wins)", 10, y);
    else
      ctx.fillText(playerNameAndId.name, 10, y);

    if (playerNameAndId && playerNameAndId.alpha > 0 && false) {
      ctx.globalAlpha = playerNameAndId.alpha;
      ctx.fillRect(60 - 50 * playerNameAndId.alpha, y, 50, 12);
    }

    y += 16;
  });

  ctx.fillStyle = "#FF0000";
  ctx.globalAlpha = 1.0;

  ctx.font = "16px Arial";
  if (myKills > 0 && false) {
    if (isTutorialMode) {
      ctx.textAlign = "right";
      ctx.fillText("Gun Lvl: " + (myKills + 1), canvas.width - 60, 30);
    } else {
      ctx.textAlign = "center";
      ctx.fillText("Gun Lvl: " + (myKills + 1), canvas.width / 2, 30);
    }
  }

  // draw powerup text
  if (myPowerup > 0 && myPlayer) {
    ctx.textAlign = "center";
    if (myPowerup == 1) {

      if (myPlayer.shield)
        ctx.fillText("Cannot use invis while shielded", canvas.width / 2, canvas.height - 60);
      else
        ctx.fillText("Space or W: activate invisibility", canvas.width / 2, canvas.height - 60);

    } else if (myPowerup == 6) {

      if (myPlayer.shield)
        ctx.fillText("Cannot teleport while shielded", canvas.width / 2, canvas.height - 60);
      else
        ctx.fillText("Space or W: teleport to cursor", canvas.width / 2, canvas.height - 60);
      
    } else if (myPowerup == 10)
      ctx.fillText("Space or W: activate blackout", canvas.width / 2, canvas.height - 60);
    else if (myPowerup == 7) {

      if (myPlayer.shield)
        ctx.fillText("Cannot use decoys while shielded", canvas.width / 2, canvas.height - 60);
      else 
        ctx.fillText("Space or W: deploy decoys", canvas.width / 2, canvas.height - 60);

    } else
      ctx.fillText("Space or W: reveal all enemies", canvas.width / 2, canvas.height - 60);
  }

  ctx.font = "10px Arial";
  ctx.textAlign = "right";
  var time = (gameNowTime - gameStartTime) / 1000;
  var secs = Math.floor(time) % 60;
  if (secs < 10)
    secs = "0" + secs;
  var mins = Math.floor(time / 60);
  if (mins < 10)
    mins = "0" + mins;

  // draw game timer
  // ctx.fillText(mins + ":" + secs, canvas.width - 10, canvas.height - 10);
  if (rankedGameInBackground) {
    ctx.fillStyle = "#0000FF";
    const largeText = matchResult || roundResult || !myPlayer;
    ctx.globalAlpha = largeText ? 1.0 : 0.7;
    ctx.font = largeText ? "16px Arial" : "13px Arial";
    let rankedSearchText = "Searching for ranked game in background";
    for (let dotCounter = 0; dotCounter < 6; dotCounter++) {
      if (dotCounter < (Date.now() / 350) % 6)
        rankedSearchText += ".";
      else
        rankedSearchText += " ";
    }
    ctx.fillText(rankedSearchText, canvas.width - 30, canvas.height - 30);
    ctx.fillStyle = "#FF0000";
    ctx.globalAlpha = 1.0;
  }

  // draw death text
  if (myKiller || !myPlayer || (myPlayer && myPlayer.poisoned)) {
    ctx.textAlign = "center";

    if (willRespawn) {

      var timeUntilSpawn = Math.ceil((respawnStartTime + GAME_CONST.RESPAWN_TIME - timeNow) / 1000);
      if (timeUntilSpawn > 0) {
        ctx.font = "17px Arial";
        ctx.fillText("respawning in " + timeUntilSpawn, canvas.width / 2, canvas.height - 150);
      }
    }

    if (myKiller) {
      ctx.font = "20px Arial";
      ctx.fillText("Killed by " + myKiller, canvas.width / 2, 180);

      if (killerPoison) {
        ctx.font = "16px Arial";
        ctx.fillText("(with poison)", canvas.width / 2, 200);

      } else if (killerInvis) {
        ctx.font = "16px Arial";
        ctx.fillText("(while invisible)", canvas.width / 2, 200);
      }

    } else if (myPlayer && myPlayer.poisoned) {

      ctx.fillStyle = "green";
      ctx.font = "17px Arial";
      var timer = Math.ceil((myPlayer.poisoned + GAME_CONST.POISON_TIME - timeNow) / 1000);
      if (timer > 0)
        ctx.fillText("Poisoned: " + timer, canvas.width / 2, canvas.height - 150);

    } else if (!willRespawn) {

      ctx.font = "17px Arial";
      ctx.fillText("you will respawn at the start of next round", canvas.width / 2, canvas.height - 150);
    }
  }

  ctx.fillStyle = "#FF0000";
  if (matchResult || roundResult) {

    ctx.textAlign = "center";
    if (matchResult) {
      ctx.font = "30px Arial";
      ctx.fillText("Winner: " + matchResult, canvas.width / 2, 140);
    } else {

      ctx.font = "24px Arial";
      if (roundResult.tie)
        ctx.fillText("Tie round!", canvas.width / 2, 140);
      else
        ctx.fillText(roundResult.winner + " won the round!", canvas.width / 2, 140);
    }
  }
  else {
    ctx.globalAlpha = 1.0;
    ctx.strokeStyle = "#FF0000";
    ctx.lineWidth = 5;

    if (!isTutorialMode && lastRevealTime && specialRound != 3) {
      if (USE_TEXT_TIMER) {
        let secs = Math.floor(maxRevealTimer / 1000) - Math.floor((timeNow - lastRevealTime) / 1000);
        if (secs < 10)
          secs = "0" + secs;

        ctx.textAlign = "right";
        ctx.font = "15px Arial";
        ctx.fillText("Reveal Threats: " + secs, canvas.width - 30, 30);

        revealAlpha -= 0.001 * dTime;
        if (revealAlpha > 0) {
          ctx.globalAlpha = revealAlpha;
          ctx.fillRect(canvas.width - 130, 34, 100, 3);
        }
      }
      else {
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(w - 30, 30, 15, 0, 2 * Math.PI * (timeNow - lastRevealTime) / (maxRevealTimer));
        ctx.stroke();
      }
    }

    var bulletRegin = GAME_CONST.BULLET_REGEN;
    if (myPlayer && myPlayer.rapidFire)
      bulletRegin = GAME_CONST.FAST_BULLET_REGEN;

    if (myBullets < maxBullets && timeNow - bulletRegin > myBulletRegenTime) {
      myBullets++;
      myBulletRegenTime += bulletRegin;
    }

    ctx.textAlign = "left";
    ctx.font = "15px Arial";
    if (tutorialState > 1 && myPlayer) {

      ctx.fillText("Bullets: " + myBullets, 30, canvas.height - 25);
      noBulletsAlpha -= 0.001 * dTime;

      if (noBulletsAlpha > 0) {
        ctx.globalAlpha = noBulletsAlpha;
        ctx.fillRect(30, canvas.height - 25 + 3, 120, 3);
      }

      if (myBullets < maxBullets) {
        var bulletTime = (timeNow - myBulletRegenTime) / bulletRegin;
        ctx.lineWidth = 4;
        ctx.beginPath();
        ctx.globalAlpha = 1.0;
        ctx.fillStyle = "#FF0000";
        ctx.arc(108, canvas.height - 30, 5, 0, 2 * Math.PI * bulletTime);
        ctx.stroke();
        ctx.lineWidth = 1;
      }
    }
  }

  updateTextBuffer(dTime);

  ctx.restore(); //And now do the redraw
  requestAnimationFrame(drawGrid);
}

function handleJoined(msg) {
  addFeedText(msg + " joined the game!");
}

function handleGamePing(msg) {
  var focus = document.hasFocus();
  if (focus) {
    io.emit("gamePong", msg);
  }
}

var debugData = null;
function handleDebugData(msg) {
  debugData = msg;
}

function handleAlertFoundGame(msg) {
  if (rankedGameInBackground) {

    var sound = document.getElementById("alert");
    sound.volume = 0.115;
    sound.play();

    addFeedText("Joining ranked game", msg.time, "blue", "rgb(230, 230, 255)");
    needToShowMessage = true;

    addGameObj(new Wave(w / 2, 100, "blue"));
    
  }
}

var specialRound = 0;
let maxWins = 4;
let maxRevealTimer = 35 * 1000;
let maxBullets = 10;
var playerNameCount = 0;

var roundStartTime = 0;
function handleInit(msg) {

  gameJoinCode = msg.gameJoinCode;
  roundStartTime = Date.now();
  myKiller = "";
  roundResult = null;
  matchResult = null;
  specialRound = msg.specialRound;
  maxWins = msg.maxWins;
  maxRevealTimer = msg.maxRevealTimer;
  maxBullets = msg.maxBullets;
  isGameRanked = msg.ranked;
  if (isGameRanked)
    rankedGameInBackground = false;

  if (!myPlayer)
    myRingAlpha = 1;

  timeNow = new Date().getTime();

  GAME_CONST = msg.GAME_CONST;
  myBullets = msg.bullets;
  currentGameId = msg.gameId;

  var oldObjs = [];
  for (var i = 0; i < gameObjects.length; i++) {
    if (gameObjects[i].preserve)
      oldObjs.push(gameObjects[i]);
  }
  gameObjects.length = 0;
  for (var i = 0; i < oldObjs.length; i++)
    addGameObj(oldObjs[i]);

  players = {};
  myId = msg.id;
  myIdOrig = msg.id;

  lastRevealTime = msg.lastRevealTime - msg.time + timeNow;
  numPlayers = msg.numPlayers;

  playerNameCount = playerNames ? playerNames.length : 0;
  playerNames = msg.names;

  if (playerNames) {
    for (var i = playerNameCount; i < playerNames.length; i++)
      playerNames[i].alpha = 1.0;
  }

  if (theBomb) {
    theBomb.kill();
  }

  if (theInvisField) {
    theInvisField.kill();
  }

  if (theScan) {
    theScan.kill();
  }


  theWalls = msg.walls;

  if (thePowerup) {
    thePowerup.kill();
  }
  if (msg.powerup) {
    thePowerup = new Powerup(msg.powerup.x, msg.powerup.y, msg.powerup.type);
    addGameObj(thePowerup);
  }

  if (msg.invis) {
    theInvisField = new InvisField(msg.invis.x, msg.invis.y, msg.invis.size);
    theInvisField.timeAlive = msg.invis.timeAlive;
    addGameObj(theInvisField);
  }

  if (msg.bomb) {
    theBomb = new Bomb(msg.bomb.x, msg.bomb.y, msg.bomb.size);
    theBomb.timeAlive = msg.bomb.timeAlive;
    addGameObj(theBomb);
  }

  if (msg.scan) {
    theScan = new Scan(msg.scan.x, msg.scan.y, msg.scan.sizeX, msg.scan.sizeY, msg.scan.toX, msg.scan.toY);
    theScan.timeAlive = msg.scan.timeAlive;
    addGameObj(theScan);
  }

  mines = {};
  if (msg.mines) {
    for (var key in msg.mines) {
      var serverMine = msg.mines[key];

      var mine = new Mine(serverMine.x, serverMine.y, serverMine.size);
      mine.id = serverMine.id;

      mines[serverMine.id] = mine;
    }
  }

  for (var key in msg.players) {

    var serverPlayer = msg.players[key];

    var thePlayer = new Player(serverPlayer.fromX, serverPlayer.fromY);
    thePlayer.toX = serverPlayer.toX;
    thePlayer.toY = serverPlayer.toY;
    thePlayer.invis = serverPlayer.invis;
    thePlayer.speedMult = serverPlayer.speedMult;
    thePlayer.rapidFire = serverPlayer.rapidFire;
    thePlayer.shield = serverPlayer.shield;
    thePlayer.startTime = serverPlayer.startTime - msg.time + timeNow;
    thePlayer.endTime = serverPlayer.endTime - msg.time + timeNow;

    thePlayer.id = key;
    thePlayer.rapidFire = serverPlayer.rapidFire;

    thePlayer.updateMove();
    players[key] = thePlayer;
    addGameObj(thePlayer);

    if (myId == key) {
      myPlayer = thePlayer;
      if (isShowingDeadView)
        reactRender.nothing();
      isShowingDeadView = false;
      willRespawn = false;
    }
  }

  if (!myPlayer && gameJoinCode) {
    reactRender.dead(config.BACKEND_URL + "/join/" + gameJoinCode);
    isShowingDeadView = true;
  }

  if (needToShowMessage) {

    if (myPlayer) {
      if (isShowingDeadView)
        reactRender.nothing();
      isShowingDeadView = false;
    }
    
    myPowerup = 0;
    myKills = 0;
    myBullets = maxBullets;
    myBulletRegenTime = new Date().getTime();

    makeBoxes();

    if (msg.specialRound > 0) {

      if (msg.specialRound == 1)
        myPowerup = 1;

      var roundText = "Start with invis";
      if (msg.specialRound == 2)
        roundText = "Start with shotguns";
      else if (msg.specialRound == 3)
        roundText = "No reveal threats timer";

      addFeedText(roundText, "Special Round!");

    } else if (msg.round > 1) {

      var finalRound = true;

      const gameWins = maxWins;
      playerNames.forEach(playerNameAndId => {
        if (playerNameAndId.wins < gameWins - 1)
          finalRound = false;
      });

      if (finalRound)
        addFeedText("round", "Final");
      else
        addFeedText("round", msg.round);

      new Audio('/resources/ready.wav').play();

    } else {

      if (isGameRanked)
        gameRankedBeginAlpha = 3.0;
      else {
        if (rankedGameInBackground)
          addFeedText("Searching for Ranked game in the background", undefined, "blue");
        else if (playerNames.length == 2)
          addFeedText("enemy is hidden in the crowd", playerNames.length - 1);
        else
          addFeedText("enemies are hidden in the crowd", playerNames.length - 1);
      }
    }
    needToShowMessage = false;
  }

  msg.bodies.forEach(bodyPosition => {
    addGameObj(new Body(bodyPosition.x, bodyPosition.y, bodyPosition.wasReal));
  })
};

function dist(x, y, x2, y2) {
  return Math.sqrt((x - x2) * (x - x2) + (y - y2) * (y - y2));
}

function decodeMessage(arrayBuffer) {
  // id, fromX, fromY, toX, toY, startTime, endTime, invis
  //  2,     2,     2,   2,   2,         4,       4,     1 = 19 bytes
  const view = new DataView(arrayBuffer);
  return {
    id: view.getUint16(0),
    fromX: view.getInt16(2),
    fromY: view.getInt16(4),
    toX: view.getInt16(6),
    toY: view.getInt16(8),
    startTime: view.getUint32(10),
    endTime: view.getUint32(14),
    invis: view.getInt8(18),
  };
}

function handlePoisoned(id) {
  
  if (players[id]) {
    var p = players[id];
    p.poisoned = timeNow;

    for (var i = 0; i < 10; i++)
      addGameObj(new Point(p.x, p.y, "0, 255, 0", 1, 0.002));
  }
}

function handleMove(msgBytes) {
  const msg = decodeMessage(msgBytes);
  var p = players[msg.id];
  if (p) {

    var size = 12;

    p.glow = 1.0;
    p.toX = msg.toX;
    p.toY = msg.toY;

    var d = dist(p.x, p.y, msg.fromX, msg.fromY);
    var focus = document.hasFocus();
    if (focus)
      sumFudgeDist += d;

    if (d > 60) {

      p.fromX = msg.fromX;
      p.fromY = msg.fromY;
      if (focus)
        numFudgeJumps++;

    } else {

      p.fromX = p.x;
      p.fromY = p.y;
    }

    if (timeNow - p.startTime < 140 && threatIndex && threatIndex[p.id] && aiLevel > 0)
      threatIndex[p.id] += 3;

    p.startTime = timeNow;
    p.endTime = msg.endTime - msg.startTime + timeNow;

  }
};

function handleReveal(msg) {

  if (msg.rType == 0) {
    lastRevealTime = timeNow;
    revealAlpha = 1.0;
  }

  var p = players[msg.id];
  if (p) {
    if (msg.id != myId) {

      if (threatIndex && isAiMode) {
        if (threatIndex[msg.id] < 100)
          threatIndex[msg.id] += msg.rType == 0 ? 10 : 100;
        else
          threatIndex[msg.id] += 10;

        if (aiLevel < 2)
          threatIndex[msg.id] += 10 * Math.random() - 5;
      }
    }

    p.revealTimer = timeNow + msg.dur;
    p.alpha = 0.2;

    if (msg.rType != 0) {
      var s = 24;
      addGameObj(new Box(msg.x - s / 2, msg.y - s / 2, s, s, 3, true));
      s = 30;
      addGameObj(new Box(msg.x - s / 2, msg.y - s / 2, s, s, 3, true));
    }
    var size = 14;
    addGameObj(new Trail(msg.x - size / 2, msg.y - size / 2, size, size, 1, "255, 0, 0"));
  }
};

function handleBlackout(msg) {

  blackoutAlpha = 4.0;
  blackoutText = msg + " activated blackout";
  threatIndex = [];

  if (myPlayer && isAiMode)
    myPlayer.isAiRevealed = false;
};

function handleNumPlayers(msg) {
  numPlayers = msg;
};

function handleKills(msg) {
  myKills = msg.kills;
  myRingAlpha = 1;

  if (myPlayer && isAiMode && !myPlayer.invis)
    myPlayer.isAiRevealed = true;
};

var threatIndex = null;
function handleShoot(msg) {
  var b = new Bullet(msg.x, msg.y, msg.toX, msg.toY, msg.lifeTime);

  if (isAiMode) {

    aiAlertRunPoint = { x: msg.x, y: msg.y };
    var notice = (aiLevel > 0 || Math.random() > 0.4) && (aiLevel > 1 || Math.random() > 0.2);

    if (threatIndex && notice) {
      if (threatIndex[msg.id]) {
        if (threatIndex[msg.id] < 100)
          threatIndex[msg.id] += 100;
        else
          threatIndex[msg.id] += 10;
      } else
        threatIndex[msg.id] = 100;
    }

    if (msg.id == myId && myPlayer && !myPlayer.invis && (aiLevel > 0 || Math.random() > 0.5))
      myPlayer.isAiRevealed = true;
  }

  b.ownerId = msg.id;  
  b.uid = msg.uid;
  b.radar = msg.radar;
  b.poison = msg.poison;
  b.piercing = msg.piercing;

  if (GAME_CONST.EXTRA_SFX)
    new Audio('/resources/shoot.wav').play();

  addGameObj(b);
};

function handleDshoot(msg) {

  for (var i = 0; i < gameObjects.length; i++) {
    var obj = gameObjects[i];
    if (obj.uid && obj.uid == msg.uid)
      obj.kill();
  }

  if (msg.radar && msg.radar > 0)
    addGameObj(new RadarPulse(msg.x, msg.y, msg.radar * 0.8, "red"));

  if (msg.poison)
    addGameObj(new PoisonPulse(msg.x, msg.y, GAME_CONST.POISON_RANGE * 0.8, "rgb(0, 200, 0)"));
  if (msg.c) {
    addGameObj(new Boom(msg.x, msg.y, 12, "rgba(255, 0, 0)"));
    addGameObj(new Ring(msg.x, msg.y, 1, "255, 0, 0"));
  }
};

function isPowerupSuper(type) {
  return type == 12;
}

function getPowerupColor(type) {

  var color = "0, 0, 255";
  if (type == 2)
    color = "0, 255, 0";
  else if (type == 8)
    color = "0, 255, 200";
  else if (type == 6)
    color = "128, 0, 255";
  else if (type == 3 || type == 5 || type == 11)
    color = "255, 0, 0";
  else if (type == 10)
    color = "0, 0, 40";
  else if (type == 4)
    color = "255, 0, 255";
  else if (type == 9)
    color = "255, 128, 0";
  else if (type == 7)
    color = "0, 128, 255";
  else if (type == 12)
    color = "0, 128, 0";

  return color;
}

function powerupSparks(x, y, type) {

  var color = getPowerupColor(type);
  for (var i = 0; i < 10; i++) {
    addGameObj(new Spark(x, y, Math.random() * 0.1, color));
  }

  addGameObj(new Ring(x, y, 1, color));
  addGameObj(new Ring(x, y, 0.5, color));
  addGameObj(new Ring(x, y, 1.1, color));
  addGameObj(new Ring(x, y, 0.2, color));
  addGameObj(new Fail(x, y, 4, color));

  if (isPowerupSuper(type))
    addGameObj(new Fail(x, y, 1, color));

  addGameObj(new Wave(x, y, color));

  for (var i = 0; i < 30; i++) {
    addGameObj(new Bit(x - 4 + 8 * Math.random(), y - 4 + 8 * Math.random(), color));
  }
}

var thePowerupWarn = null;
function handlePowerupWarn(msg) {

  //if (msg.type == 12)
  // addFeedText("super powerup spawning");

  var powerupWarn = new PowerupWarn(msg.x, msg.y, msg.type);
  thePowerupWarn = powerupWarn;

  if (thePowerup)
    thePowerup.kill();

  thePowerup = null;
  addGameObj(powerupWarn);
}
function handlePowerup(msg) {

  var powerup = new Powerup(msg.x, msg.y, msg.type);
  powerup.alpha = 1;

  powerupSparks(msg.x, msg.y, msg.type);

  if (thePowerup)
    thePowerup.kill();

  thePowerup = powerup;
  addGameObj(powerup);
}

function handleBomb(msg) {

  var bomb = new Bomb(msg.x, msg.y, msg.size);

  bomb.alpha = 1;

  if (theBomb)
    theBomb.kill();

  theBomb = bomb;
  addGameObj(bomb);
}

function handleInvisField(msg) {

  var invis = new InvisField(msg.x, msg.y, msg.size);
  invis.alpha = 1;

  if (theInvisField)
    theInvisField.kill();

  theInvisField = invis;
  addGameObj(invis);
}

function handleScan(msg) {

  var scan = new Scan(msg.x, msg.y, msg.sizeX, msg.sizeY, msg.toX, msg.toY);
  scan.alpha = 1;

  if (theScan)
    theScan.kill();

  theScan = scan;
  addGameObj(scan);
}

function handleMine(msg) {

  var mine = new Mine(msg.x, msg.y, msg.size);
  mine.id = msg.id;
  mine.alpha = 1;

  mines[msg.id] = mine;
  addGameObj(mine);
}

function handleDMine(msg) {

}

function handleWalls(msg) {

  theWalls = msg;
}

function handlePowerDest(msg) {

  if (thePowerup) {

    if (isAiMode && (aiLevel > 0 || Math.random() > 0.5)) {
      var bestDist = 50;
      var bestPlayer = null;

      for (var key in players) {
        var p = players[key];
        var d = dist(thePowerup.x, thePowerup.y, p.x, p.y);
        if (d < bestDist) {
          bestDist = d;
          bestPlayer = p;
        }
      }

      if (bestPlayer) {
        threatIndex[bestPlayer.id] += 100;
      }
    }

    thePowerup.kill();
    thePowerup = null;
  }
}

function handlePowerGet(msg) {

  myPowerup = msg;
  if (GAME_CONST.EXTRA_SFX)
    new Audio('/resources/getpower.wav').play();

  if (isAiMode && myPlayer && msg > 0)
    myPlayer.isAiRevealed = true;
}

function handleNew(serverPlayer) {

  if (players[serverPlayer.id])
    return;

  var thePlayer = new Player(serverPlayer.fromX, serverPlayer.fromY);
  thePlayer.toX = serverPlayer.toX;
  thePlayer.toY = serverPlayer.toY;
  thePlayer.startTime = timeNow;

  for (var i = 0; i < 5; i++)
    addGameObj(new Bit(thePlayer.x - 4 + 8 * Math.random(), thePlayer.y - 4 + 8 * Math.random(), "0, 0, 0", 0.25));

  var timeAdd = Math.sqrt((thePlayer.toX - thePlayer.fromX) * (thePlayer.toX - thePlayer.fromX) +
    (thePlayer.toY - thePlayer.fromY) * (thePlayer.toY - thePlayer.fromY)) * GAME_CONST.PLAYER_SPEED / thePlayer.speedMult;
  if (timeAdd < 1)
    timeAdd = 1;

  thePlayer.endTime = timeNow + timeAdd;

  if (serverPlayer.shield)
    thePlayer.shield = true;
  if (serverPlayer.speedMult)
    thePlayer.speedMult = serverPlayer.speedMult;

  thePlayer.id = serverPlayer.id;

  thePlayer.updateMove();
  players[thePlayer.id] = thePlayer;
  addGameObj(thePlayer);

  if (isAiMode) {
    if (aiNewAlert + 1000 * 4 > timeNow)
      threatIndex[thePlayer.id] = 5 + 5 * aiLevel;
    else
      threatIndex[thePlayer.id] = -5 * aiLevel;
  }

  if (thePlayer.id == myId) {
    myPlayer = thePlayer;
    if (isShowingDeadView)
      reactRender.nothing();
    isShowingDeadView = false;
    willRespawn = false;
    myKiller = "";
  }
};

var killerInvis = false;
var killerPoison = false;
var myKiller = "";

function handleDisconnect(msg) {
  addFeedText(msg + " disconnected");
}

function handleDie(msg) {

  if (msg.killer) {
    if (msg.id == myId) {
      myKiller = msg.killer.name;
      killerInvis = msg.killer.invis;
      killerPoison = msg.killer.poisoned;
    }
    else if (msg.killer.myName) {
      if (msg.killer.id == myId)
        addFeedText("You killed " + msg.killer.myName);
      else
        addFeedText(msg.killer.name + " killed " + msg.killer.myName);
    }
  }

  if (msg.id == myId) {
    myPlayer = null;
    if (gameJoinCode) {
      reactRender.dead(config.BACKEND_URL + "/join/" + gameJoinCode);
      isShowingDeadView = true;
    }
  }

  if (msg.fx) {
    var b = new Body(msg.x, msg.y, msg.wasReal, msg.poisoned);

    b.alpha = 1.0;

    var size = 10;
    addGameObj(new Trail(msg.x - size / 2, msg.y - size / 2, size, size, 1, "0, 0, 0"));

    addGameObj(new Line(this.x - size / 2, this.y - size / 2, this.x + size / 2, this.y - size / 2, "0, 0, 0", Math.random(), 0.001));
    addGameObj(new Line(this.x - size / 2, this.y + size / 2, this.x + size / 2, this.y + size / 2, "0, 0, 0", Math.random(), 0.001));

    addGameObj(new Line(this.x - size / 2, this.y - size / 2, this.x - size / 2, this.y + size / 2, "0, 0, 0", Math.random(), 0.001));
    addGameObj(new Line(this.x + size / 2, this.y - size / 2, this.x + size / 2, this.y + size / 2, "0, 0, 0", Math.random(), 0.001));

    addGameObj(b);

    if (msg.wasReal) {
      playerDeath(msg.x, msg.y)
    }
  }

  if (players[msg.id]) {
    players[msg.id].kill();
    delete players[msg.id];
  }
}

function playerDeath(x, y) {

  if (GAME_CONST.EXTRA_SFX)
    new Audio('/resources/die.wav').play();
  addGameObj(new Boom(x, y));
  addGameObj(new Fail(x, y, 4, "255, 0, 0"));
  addGameObj(new Ring(x, y, 1, "255, 0, 0"));
  addGameObj(new Ring(x, y, 0.5, "255, 0, 0"));
  addGameObj(new Ring(x, y, 1.1, "255, 0, 0"));
  addGameObj(new Wave(x, y, "red"));

  for (var i = 0; i < 5; i++) {
    var s = Math.random() * 10;
    var x = x - 10 + Math.random() * 20;
    var y = y - 10 + Math.random() * 20;
    addGameObj(new Box(x - s / 2, y - s / 2, s, s, 5 * Math.random(), true));
  }
}

function Wave(x, y, color) {
  this.alpha = 1.0;
  this.x = x;
  this.y = y;
  this.color = color;
  this.preserve = true;
}

Wave.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.001;
  if (this.alpha <= 0) {
    this.alpha = 0;
  }
  else {
    ctx.beginPath();
    ctx.lineWidth = 4;
    ctx.globalAlpha = this.alpha;
    ctx.strokeStyle = this.color;
    const rad = (1 - this.alpha) * (ctx.canvas.width + ctx.canvas.height) / 2;
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, 0, Math.PI * 2)
    ctx.lineWidth = 1;
    ctx.stroke();
  }
}

function showReplayView(id) {
  endGame();
  if (returnToLobbyInsteadOfMainMenuFromReplay)
    replay.entry(id, () => { findGameFunction(mainMenuFunction); }, myId, findGameText);
  else
    replay.entry(id, () => { mainMenuFunction(isGameRanked); }, myId);
}

var matchResultData;
function handleReplayReady(msg) {
  
  if (msg.gameId === currentGameId && matchResultData) {
    gameRankedBeginAlpha = 0.0;
    matchResultData.replayReady = true;
    reactRender.end(matchResult,
      findGameText,
      () => { endGame(); findGameFunction(mainMenuFunction, isGameRanked); },
      () => { endGame(); mainMenuFunction(isGameRanked); },
      () => { showReplayView(msg.replayId); },
      matchResultData.rank, matchResultData.deltaRank, matchResultData.mmr, matchResultData.deltaMmr,
      matchResultData.replayReady, isGameRanked, rankedGameInBackground);
  }
}

function handleRoundResult(msg) {
  resetGlobalVars();
  matchResultData = null;
  roundResult = msg;

  if (gameJoinCode && !myPlayer) {
    reactRender.dead(config.BACKEND_URL + "/join/" + gameJoinCode);
    isShowingDeadView = true;
  }

  // send metrics at the end of each round
  var time = (Date.now() - roundStartTime) / (1000 * 60);
  observeHistogramMetric("hard_jumps_per_minute", numFudgeJumps / time);
}
function handleMatchResult(msg) {
  
  if (msg.gameId === currentGameId) {
    gameRankedBeginAlpha = 0.0;
    matchResultData = msg;
    matchResult = msg.winner;
    playerNames = msg.names;

    reactRender.end(matchResult,
      findGameText,
      () => { endGame(); findGameFunction(mainMenuFunction, isGameRanked); },
      () => { endGame(); mainMenuFunction(isGameRanked); },
      () => { showReplayView(msg.replayId); },
      msg.rank, msg.deltaRank, msg.mmr, msg.deltaMmr,
      matchResultData.replayReady, isGameRanked, rankedGameInBackground);
  }
}

var respawnStartTime = 0;
var willRespawn = false;
function handleRespawnCount(msg) {
  respawnStartTime = timeNow;
  willRespawn = true;
}

function handleRespawn(msg) {

  for (var i = 0; i < 30; i++) {
    addGameObj(new Bit(msg.x - 4 + 8 * Math.random(), msg.y - 4 + 8 * Math.random(), "255, 0, 0"));
  }

  for (var i = 0; i < 5; i++) {
    var s = Math.random() * 30;
    var x = msg.x - 40 + Math.random() * 80;
    var y = msg.y - 40 + Math.random() * 80;
    addGameObj(new Box(x - s / 2, y - s / 2, s, s, 5 * Math.random(), true));
  }

  addGameObj(new Wave(msg.x, msg.y, "255, 0, 0"));
  if (msg.y > 100)
    addGameObj(new Text(msg.x, msg.y - 40, msg.name, "(one life left)", "255, 0, 0"));
  else
    addGameObj(new Text(msg.x, msg.y + 60, msg.name, "\n(one life left)", "255, 0, 0"));
}

function handleNames(msg) {
  playerNames = msg;
}

var aiNewAlert = 0;
function handleTp(msg) {

  addGameObj(new Ring(msg.x, msg.y, 1, "128, 0, 255"));
  addGameObj(new Ring(msg.x, msg.y, 0.5, "128, 0, 255"));
  addGameObj(new Ring(msg.x, msg.y, 1.1, "128, 0, 255"));

  var size = 12;
  addGameObj(new Trail(msg.x - size / 2, msg.y - size / 2, size, size, 1.5, "127, 0, 255"), false, 0.5);
  addGameObj(new Trail(msg.x - size / 2, msg.y - size / 2, size, size, 1.5, "128, 0, 255"), true, 1);
  aiNewAlert = timeNow;
}

function handleRapidFire(msg) {

  if (players[msg.id]) {
    players[msg.id].rapidFire = true;

    if (isAiMode) {
      if (threatIndex && threatIndex[msg.id])
        threatIndex[msg.id] += 100;
      if (msg.id == myId && myPlayer)
        myPlayer.isAiRevealed = true;
    }
  }
}

function handleFast(msg) {

  if (players[msg.id]) {
    players[msg.id].speedMult = msg.speedMult;
    if (threatIndex && threatIndex[msg.id])
      threatIndex[msg.id] += 100;
  }
}

function invisFx(msg) {

  addGameObj(new Ring(msg.x, msg.y, 1, "0, 0, 255"));
  addGameObj(new Ring(msg.x, msg.y, 0.5, "0, 0, 255"));
  addGameObj(new Ring(msg.x, msg.y, 1.1, "0, 0, 255"));

  var size = 12;
  addGameObj(new Trail(msg.x - size / 2, msg.y - size / 2, size, size, 1.5, "0, 0, 255"), false, 0.5);
  addGameObj(new Trail(msg.x - size / 2, msg.y - size / 2, size, size, 1.5, "0, 0, 255"), true, 1);
}

var aiAlertRunPoint = null;
var aiInvisWarning = 0;
function handleInvis(msg) {

  invisFx(msg);

  if (msg.id != myId) {
    aiAlertRunPoint = { x: msg.x, y: msg.y };
    aiInvisWarning = timeNow + GAME_CONST.INVIS_TIME;
    aiNewAlert = timeNow + GAME_CONST.INVIS_TIME;

    if (players[msg.id])
      players[msg.id].kill();
  }
  else {
    myPlayer.invisTimer = timeNow;
    myPlayer.isAiRevealed = false;

    if (GAME_CONST.EXTRA_SFX)
      new Audio('/resources/cloak.wav').play();

    myPlayer.invis = true;
    myPowerup = 0;
  }
}

function handleShield(msg) {

  addGameObj(new Ring(msg.x, msg.y, 1, "0, 255, 0"));
  addGameObj(new Ring(msg.x, msg.y, 0.5, "0, 255, 0"));
  addGameObj(new Ring(msg.x, msg.y, 1.1, "0, 255, 0"));

  if (players[msg.id]) {
    players[msg.id].shield = true;
    players[msg.id].poisoned = 0;
    players[msg.id].shieldTimer = timeNow;

    if (threatIndex && threatIndex[msg.id])
      threatIndex[msg.id] += 100;
  }
}

function handleDShield(msg) {
  if (players[msg.id]) {
    var p = players[msg.id];
    p.shield = false;

    addGameObj(new Ring(p.x, p.y, 1, "0, 255, 0"));
    addGameObj(new Ring(p.x, p.y, 0.5, "0, 255, 0"));
    addGameObj(new Ring(p.x, p.y, 1.1, "0, 255, 0"));

    for (var i = 0; i < 10; i++)
      addGameObj(new Point(p.x, p.y, "0, 255, 0", 1, 0.002));
  }
}

function InvisField(x, y, size) {

  this.x = x;
  this.y = y;
  this.size = size;
  this.drawSize = 0;
  this.timeAlive = 0;
  this.alpha = 0;
}
InvisField.prototype.update = function (dTime, ctx) { }
InvisField.prototype.overUpdate = function (dTime, ctx) {

  this.timeAlive += dTime;

  if (this.timeAlive > GAME_CONST.INVIS_LIFE_TIME) {
    this.kill();
    return;
  }

  this.drawSize = Math.min(this.timeAlive / GAME_CONST.INVIS_SCALE_TIME, (GAME_CONST.INVIS_LIFE_TIME - this.timeAlive) / GAME_CONST.INVIS_SCALE_TIME) * this.size;
  if (this.drawSize > this.size)
    this.drawSize = this.size;

  ctx.lineWidth = 2;
  ctx.fillStyle = "#0000FF";
  ctx.strokeStyle = "#0000FF";

  ctx.beginPath();
  if (this.drawSize > 0)
    ctx.arc(this.x, this.y, this.drawSize, 0, 2 * Math.PI);
  ctx.globalAlpha = 0.2;
  ctx.fill();

  ctx.globalAlpha = 1.0;
  ctx.stroke();
}

function Mine(x, y, size) {

  this.x = x;
  this.y = y;
  this.size = size;
  this.timeAlive = 0;
  this.alpha = 0;
}

Mine.prototype.update = function (dTime, ctx) { }
Mine.prototype.overUpdate = function (dTime, ctx) {

  ctx.globalAlpha = 1.0;
  ctx.lineWidth = 1;
  ctx.fillStyle = "#000000";
  ctx.strokeStyle = "#FF0000";
  ctx.beginPath();

  var shudderX = 0;
  var shudderY = 0;

  var size = 10;
  ctx.beginPath();
  ctx.arc(this.x + shudderX, this.y + shudderY, size, 0, 2 * Math.PI);
  ctx.fill();
  ctx.stroke();

  ctx.fillStyle = "#FF0000";
  var size = 4;
  ctx.beginPath();
  ctx.arc(this.x + shudderX, this.y + shudderY, size, 0, 2 * Math.PI);
  ctx.fill();

  this.timeAlive += dTime;
  this.drawSize = 0;
  if (this.timeAlive > GAME_CONST.BOMB_DROP_TIME) {


    ctx.globalAlpha = 1.0;
    var size = this.size * Math.min(1.0, (this.timeAlive - GAME_CONST.BOMB_DROP_TIME) / GAME_CONST.BOMB_EX_TIME);
    this.drawSize = size;

    ctx.strokeStyle = "#FF0000";
    ctx.lineWidth = 2;
    ctx.beginPath();
    if (size > 0)
      ctx.arc(this.x, this.y, size, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.fillStyle = "#FF0000";
    ctx.globalAlpha = 0.2;
    ctx.fill();

    ctx.globalAlpha = 1;
    ctx.lineWidth = 2;

    var doneMove = false;
    var origX = this.x;
    var origY = this.y;

    ctx.lineTo(origX, origY);
    ctx.stroke();
  }

  ctx.globalAlpha = 0.5;
  ctx.lineWidth = 1;
  ctx.strokeStyle = "#FF0000";
  ctx.beginPath();
  if (this.size > 0)
    ctx.arc(this.x, this.y, this.size, 0, 2 * Math.PI);
  ctx.stroke();

  ctx.globalAlpha = 1.0;
  ctx.strokeStyle = "black";
  ctx.lineWidth = 3;
  ctx.beginPath();
  var arc = 2 * Math.PI * (timeNow - this.spawnTime) / 1000;
  {
    const rad = 20 - 15 * Math.cos((timeNow - this.spawnTime) / 5000);
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, arc, arc + Math.PI / 9);
  }
  ctx.stroke();

  ctx.beginPath();
  var arc = 2 * Math.PI * (timeNow - this.spawnTime) / 900;
  {
    const rad = 15 - 10 * Math.cos((timeNow - this.spawnTime) / 4000);
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, arc, arc + Math.PI / 9);
  }
  ctx.stroke();
}

function Scan(x, y, sizeX, sizeY, toX, toY) {

  this.x = x;
  this.y = y;
  this.sizeX = sizeX;
  this.sizeY = sizeY;
  this.toX = toX;
  this.toY = toY;
  this.timeAlive = 0;
  this.alpha = 0;
  this.trailTimer = 0;
}

Scan.prototype.update = function (dTime, ctx) {


  this.timeAlive += dTime;
  var mult = this.timeAlive / GAME_CONST.SCAN_BOX_FALL_TIME;
  var x = this.x + (this.toX - this.x) * mult;
  var y = this.y + (this.toY - this.y) * mult;
  this.xNow = x;
  this.yNow = y;

  this.trailTimer += dTime;
  if (this.trailTimer > 400) {
    this.trailTimer -= 400;

    addGameObj(new Trail(x - this.sizeX / 2, y - this.sizeY / 2, this.sizeX, this.sizeY, 1, "255, 0, 0"));
  }

  ctx.globalAlpha = 1.0;
  ctx.lineWidth = 1;
  ctx.strokeStyle = "#FF0000";
  ctx.fillStyle = "#FF0000";

  ctx.beginPath();
  ctx.rect(x - this.sizeX / 2, y - this.sizeY / 2, this.sizeX, this.sizeY);
  ctx.stroke();

  ctx.globalAlpha = 0.2;
  ctx.fill();
}


function Bomb(x, y, size) {

  this.x = x;
  this.y = y;
  this.size = size;
  this.timeAlive = 0;
  this.alpha = 0;
  this.spawnTime = timeNow;
  this.sizeMult = 1.0;
}

Bomb.prototype.update = function (dTime, ctx) { }
Bomb.prototype.overUpdate = function (dTime, ctx) {

  ctx.globalAlpha = 1.0;
  ctx.lineWidth = 1;
  ctx.fillStyle = "#000000";
  ctx.strokeStyle = "#FF0000";
  ctx.beginPath();

  var shudderX = Math.random() * 4 - 2;
  var shudderY = Math.random() * 4 - 2;

  var size = 14;
  ctx.beginPath();
  ctx.arc(this.x + shudderX, this.y + shudderY, size, 0, 2 * Math.PI);
  ctx.fill();
  ctx.stroke();

  ctx.fillStyle = "#FF0000";
  var size = 6 * this.sizeMult;
  ctx.beginPath();
  if (size > 0)
    ctx.arc(this.x + shudderX, this.y + shudderY, size, 0, 2 * Math.PI);
  ctx.fill();

  if (Math.random() > 0.9)
    addGameObj(new Spark(this.x, this.y, Math.random() * 0.2, "255, 0, 0"));

  this.drawSize = 0;
  this.timeAlive += dTime;
  if (this.timeAlive > GAME_CONST.BOMB_DROP_TIME) {
    if (this.timeAlive > GAME_CONST.BOMB_DROP_TIME + GAME_CONST.BOMB_EX_TIME) {

      this.sizeMult -= 0.0025 * dTime;
      if (this.sizeMult < 0) {

        var color = "255, 0, 0";
        var x = this.x;
        var y = this.y;
        addGameObj(new Ring(x, y, 1, color));
        addGameObj(new Ring(x, y, 0.5, color));
        addGameObj(new Ring(x, y, 1.1, color));
        addGameObj(new Ring(x, y, 2, color));
        addGameObj(new Ring(x, y, 0.2, color));
        addGameObj(new Fail(x, y, 4, color));
        addGameObj(new Wave(x, y, color));
        addGameObj(new Boom(x, y, 35));

        for (var i = 0; i < 5; i++) {
          var s = Math.random() * 30;
          var x = this.x - 10 + Math.random() * 20;
          var y = this.y - 10 + Math.random() * 20;
          addGameObj(new Box(x - s / 2, y - s / 2, s, s, 4 * Math.random(), true));
        }

        this.kill();
        return;
      }
    }


    ctx.globalAlpha = 1.0;
    var size = this.size * (this.timeAlive - GAME_CONST.BOMB_DROP_TIME) / GAME_CONST.BOMB_EX_TIME * this.sizeMult;
    this.drawSize = size;

    ctx.strokeStyle = "#FF0000";
    ctx.lineWidth = 2;
    ctx.beginPath();
    if (size > 0)
      ctx.arc(this.x, this.y, size, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.fillStyle = "#FF0000";
    ctx.globalAlpha = 0.2;
    ctx.fill();

    ctx.globalAlpha = 1;
    ctx.lineWidth = 2;

    var doneMove = false;
    var origX = this.x;
    var origY = this.y;

    for (var rot = 0; rot <= Math.PI * 2; rot += Math.PI / 60) {
      var shudderX = 4 - 8 * Math.random();
      var shudderY = 4 - 8 * Math.random();
      var x = this.x + Math.cos(rot) * size + shudderX;
      var y = this.y + Math.sin(rot) * size + shudderY;

      if (!doneMove) {
        origX = x;
        origY = y;
        doneMove = true;
        ctx.moveTo(x, y);
        ctx.beginPath();
      } else
        ctx.lineTo(x, y);
    }

    ctx.lineTo(origX, origY);
    ctx.stroke();
  }

  ctx.globalAlpha = 0.5;
  ctx.lineWidth = 1;
  ctx.strokeStyle = "#FF0000";
  ctx.beginPath();
  if (this.size * this.sizeMult > 0)
    ctx.arc(this.x, this.y, this.size * this.sizeMult, 0, 2 * Math.PI);
  ctx.stroke();

  ctx.globalAlpha = 1.0;
  ctx.strokeStyle = "black";
  ctx.lineWidth = 3;
  ctx.beginPath();
  var arc = 2 * Math.PI * (timeNow - this.spawnTime) / 1000;
  {
    const rad = 20 - 15 * Math.cos((timeNow - this.spawnTime) / 5000);
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, arc, arc + Math.PI / 9);
  }
  ctx.stroke();

  ctx.beginPath();
  var arc = 2 * Math.PI * (timeNow - this.spawnTime) / 900;

  {
    const rad = 15 - 10 * Math.cos((timeNow - this.spawnTime) / 4000);
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, arc, arc + Math.PI / 9);
  }
  ctx.stroke();
}

function drawWalls(offset) {

  if (theWalls) {

    // left
    ctx.beginPath();
    ctx.moveTo(theWalls.left + offset, theWalls.top);
    ctx.lineTo(theWalls.left + offset, h - theWalls.bottom);
    ctx.stroke();

    // right
    ctx.beginPath();
    ctx.moveTo(w - theWalls.right - offset, theWalls.top);
    ctx.lineTo(w - theWalls.right - offset, h - theWalls.bottom);
    ctx.stroke();

    // top
    ctx.beginPath();
    ctx.moveTo(theWalls.left, theWalls.top + offset);
    ctx.lineTo(w - theWalls.right, theWalls.top + offset);
    ctx.stroke();

    // botttom
    ctx.beginPath();
    ctx.moveTo(theWalls.left, h - theWalls.bottom - offset);
    ctx.lineTo(w - theWalls.right, h - theWalls.bottom - offset);
    ctx.stroke();
  }
}


function PowerupWarn(x, y, type) {

  this.x = x;
  this.y = y;
  this.type = type;
  this.color = getPowerupColor(type);
  this.spawnTime = timeNow;
  this.alpha = 0;
}

PowerupWarn.prototype.update = function update(dTime, ctx) { }
PowerupWarn.prototype.overUpdate = function update(dTime, ctx) {

  if (timeNow - this.spawnTime > GAME_CONST.POWERUP_SPAWN_TIME) {
    this.kill();
    return;
  }

  ctx.globalAlpha = 1.0;
  ctx.strokeStyle = "rgb(" + this.color + ")";
  ctx.fillStyle = "rgb(" + this.color + ")";
  ctx.lineWidth = 3;
  ctx.beginPath();
  var arc = 2 * Math.PI * (timeNow - this.spawnTime) / (GAME_CONST.POWERUP_SPAWN_TIME) * 15;
  {
    const rad = 20 - 20 * (timeNow - this.spawnTime) / GAME_CONST.POWERUP_SPAWN_TIME;
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, arc - Math.PI / 9, arc);
  }
  ctx.stroke();

  arc += Math.PI;
  ctx.beginPath();
  {
    const rad = 25 - 25 * (timeNow - this.spawnTime) / GAME_CONST.POWERUP_SPAWN_TIME;
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, arc - Math.PI / 8, arc);
  }
  ctx.stroke();

  this.alpha += 0.0001 * dTime;
  if (this.alpha > 1)
    this.alpha = 1;

  if (true || isPowerupSuper(this.type))
    drawPowerupText(this.x, this.y, this.type, this.alpha * 0.75);

  if (Math.random() > 0.9)
    addGameObj(new Spark(this.x, this.y, Math.random() * 0.1, this.color.replace("rgb(", "").replace(")", "")));
  if (Math.random() > 0.975)
    addGameObj(new Ring(this.x, this.y, -Math.random() * Math.random() * 1.5 - 0.2, this.color));
  if (Math.random() > 0.975)
    addGameObj(new Ring(this.x, this.y, 0.2 + Math.random(), this.color));
}

function shadowText(ctx, text, x, y) {
  var fillStyle = ctx.fillStyle;
  var alpha = ctx.globalAlpha;

  ctx.globalAlpha = Math.min(alpha, 1.0) / 10;

  ctx.fillStyle = "black";
  ctx.fillText(text, x + 0.5, y + 0.5);
  ctx.globalAlpha = alpha;
  ctx.fillStyle = fillStyle;
  ctx.fillText(text, x, y);

}

function Powerup(x, y, type) {

  this.x = x;
  this.y = y;
  this.type = type;
  this.alpha = 1.0;

  this.color = getPowerupColor(type);
  this.timeAlive = 0;
}

function getPowerupText(type) {
  var text = "invis";

  if (type == 2)
    text = "shield"
  else if (type == 3)
    text = "shotgun"
  else if (type == 4)
    text = "range"
  else if (type == 5)
    text = "reveal"
  else if (type == 6)
    text = "teleport"
  else if (type == 7)
    text = "decoys"
  else if (type == 8)
    text = "speed"
  else if (type == 9)
    text = "rapid fire"
  else if (type == 10)
    text = "blackout"
  else if (type == 11)
    text = "radar shot"
  else if (type == 12)
    text = "super poison shot"

  return text;
}

function drawPowerupText(x, y, type, alpha) {
  ctx.globalAlpha = alpha;
  var text = getPowerupText(type);

  ctx.textAlign = "center";
  var px = x;
  if (px < 50)
    px += 20;
  if (px > w - 50)
    px -= 20;

  if (y > 200)
    shadowText(ctx, text, px, y - 30);
  else
    ctx.fillText(text, px, y + 40);
}

Powerup.prototype.update = function (dTime, ctx) { }
Powerup.prototype.overUpdate = function (dTime, ctx) {

  this.timeAlive += dTime;

  ctx.globalAlpha = 1.0;
  ctx.lineWidth = 1.0;
  ctx.strokeStyle = "rgb(" + this.color + ")";
  ctx.fillStyle = "rgb(" + this.color + ")";

  var rot = this.timeAlive * 0.0005;
  ctx.beginPath();
  ctx.arc(this.x, this.y, 5 + 2 * Math.cos(this.timeAlive * 0.002), rot, rot + Math.PI);
  ctx.stroke();

  rot *= 1.25;
  ctx.beginPath();
  ctx.arc(this.x, this.y, 3 + 2 * Math.cos(this.timeAlive * 0.0025), rot, rot + Math.PI);
  ctx.stroke();

  if (this.alpha > 0) {
    this.alpha -= dTime * 0.000025;
    if (this.alpha > 0) {
      drawPowerupText(this.x, this.y, this.type, this.alpha);
    }
  }

  var strokeColor = "black";
  if (isPowerupSuper(this.type))
    strokeColor = "rgb(100, 255, 100)";

  var size2 = 10;
  ctx.globalAlpha = 0.2;
  ctx.beginPath();
  ctx.rect(this.x - size2 / 2, this.y - size2 / 2 + 2, size2, size2);
  ctx.strokeStyle = strokeColor;
  ctx.stroke();
  ctx.fill();


  var size3 = 12;
  ctx.beginPath();
  ctx.rect(this.x - size3 / 2, this.y - size3 / 2, size3, size3);
  ctx.strokeStyle = "white";
  ctx.stroke();

  ctx.globalAlpha = 1.0;
  ctx.beginPath();
  ctx.rect(this.x - size2 / 2, this.y - size2 / 2, size2, size2);
  ctx.strokeStyle = strokeColor;
  ctx.stroke();
  ctx.fill();

  if (Math.random() > 0.9)
    addGameObj(new Spark(this.x, this.y, Math.random() * 0.05, this.color.replace("rgb(", "").replace(")", "")));

  if (isTutorialMode && dist(myPlayer.x, myPlayer.y, this.x, this.y) < 15) {
    setTutorial(8);
    myPowerup = 1;
    this.kill();

    if (GAME_CONST.EXTRA_SFX)
      new Audio('/resources/getpower.wav').play();
    return;
  }
}


function Bullet(x, y, toX, toY, lifeTime) {

  this.x = x;
  this.y = y;
  this.timeAlive = 0;
  this.lifeTime = lifeTime;

  var dist = Math.sqrt((toX - x) * (toX - x) + (toY - y) * (toY - y)) * GAME_CONST.BULLET_SPEED;
  if (dist > 0) {
    this.dx = (toX - x) / dist;
    this.dy = (toY - y) / dist;
  }

  this.trailTimer = 0;
}

Bullet.prototype.kill = function () {

  if (this.toKill)
    return;

  this.toKill = true;
  var size = 8;

  var color = "255, 0, 0";
  if (this.poison)
    color = "0, 128, 0";

  addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 0.35, color, false, 1));

  if (this.lifeTime > GAME_CONST.BASE_BULLET_LIFETIME || this.poison) {
    addGameObj(new Ring(this.x, this.y, 0.3, color));

    if (this.lifeTime > GAME_CONST.BASE_BULLET_LIFETIME) {
      for (var i = 0; i < 5; i++)
        addGameObj(new Bit(this.x - 4 + 8 * Math.random(), this.y - 4 + 8 * Math.random(), color, 0.4));
    }

    for (var i = 0; i < 10; i++)
      addGameObj(new Point(this.x, this.y, color, 1, 0.002));

    if (this.lifeTime > GAME_CONST.BASE_BULLET_LIFETIME * 2.1) {

      for (var i = 0; i < 10; i++)
        addGameObj(new Point(this.x, this.y, color, 1, 0.001));
    }
  }
}


function TriTrail(x, y, s, a, color, rot) {
  this.alpha = a;

  this.x = x;
  this.y = y;
  this.s = s;
  this.color = color;
  this.rot = rot;
}

TriTrail.prototype.update = function (dTime, ctx) { }
TriTrail.prototype.underUpdate = function (dTime, ctx) {

  this.alpha -= dTime * 0.001;
  if (this.alpha <= 0) {
    kill(this);
    return;
  }
  else {
    ctx.globalAlpha = Math.min(this.alpha, 1.0) * 0.1;

    ctx.strokeStyle = "rgb(" + this.color + ")";
    ctx.lineWidth = 2;
    ctx.beginPath();

    var dir = this.rot;
    var dist = this.s;
    {
      var rot = dir - Math.PI * 0.66;
      var x = this.x + Math.cos(rot) * dist;
      var y = this.y + Math.sin(rot) * dist;

      ctx.moveTo(x, y);
    }
    {
      var rot = dir;
      var x = this.x + Math.cos(rot) * dist;
      var y = this.y + Math.sin(rot) * dist;

      ctx.lineTo(x, y);
    }
    {
      var rot = dir + Math.PI * 0.66;
      var x = this.x + Math.cos(rot) * dist;
      var y = this.y + Math.sin(rot) * dist;

      ctx.lineTo(x, y);
    }
    ctx.stroke();
    ctx.lineWidth = 1;
  }
}


Bullet.prototype.update = function (dTime, ctx) {

  this.timeAlive += dTime;
  if (this.timeAlive > this.lifeTime) {
    this.kill();
    return;
  }

  this.trailTimer += dTime;
  var rgbColor = "255, 0, 0";
  if (this.poison)
    rgbColor = "0, 128, 0";

  if (roundResult && false) {

    if (!this.color) {
      this.color = {};
      this.color.r = 128 * Math.random();
      this.color.g = 128 * Math.random();
      this.color.b = 128 * Math.random();
      if (Math.random() > 0.33)
        this.color.r = 255;
      else if (Math.random() > 0.5)
        this.color.g = 255;
      else
        this.color.b = 255;

      this.colorTime = 0;
    }

    this.colorTime += dTime;
    if (this.colorTime > 250) {
      this.colorTime -= 250;

      this.color.r = 128 * Math.random();
      this.color.g = 128 * Math.random();
      this.color.b = 128 * Math.random();
      if (Math.random() > 0.33)
        this.color.r = 255;
      else if (Math.random() > 0.5)
        this.color.g = 255;
      else
        this.color.b = 255;
    }

    rgbColor = this.color.r + "," + this.color.b + "," + this.color.g;
  }

  var dir = -Math.atan2(this.dx, this.dy) + Math.PI / 2;
  if (this.trailTimer > 100) {
    this.trailTimer -= 100;

    var size = 6;
    var lifeTime = 1.5 * this.lifeTime / GAME_CONST.BASE_BULLET_LIFETIME;
    if (roundResult)
      lifeTime *= 5;
    if (this.piercing)
      addGameObj(new TriTrail(this.x, this.y, size, lifeTime, rgbColor, dir));
    else
      addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, lifeTime, rgbColor, true, 0.15 * this.lifeTime / GAME_CONST.BASE_BULLET_LIFETIME));

    if (this.lifeTime > GAME_CONST.BASE_BULLET_LIFETIME || this.poison)
      addGameObj(new Point(this.x, this.y, rgbColor, 1, 0.001 * GAME_CONST.BASE_BULLET_LIFETIME / this.lifeTime));
  }

  this.x += this.dx * dTime;
  this.y += this.dy * dTime;

  var color = "rgb(" + rgbColor + ")";

  ctx.fillStyle = color;
  ctx.strokeStyle = color;

  if (this.piercing) {

    ctx.globalAlpha = 1;
    ctx.lineWidth = 2;
    ctx.beginPath();

    var offset = 6;
    {
      var rot = dir - Math.PI * 0.66;
      var x = this.x + Math.cos(rot) * offset;
      var y = this.y + Math.sin(rot) * offset;

      ctx.moveTo(x, y);
    }
    {
      var rot = dir;
      var x = this.x + Math.cos(rot) * offset;
      var y = this.y + Math.sin(rot) * offset;

      ctx.lineTo(x, y);
    }
    {
      var rot = dir + Math.PI * 0.66;
      var x = this.x + Math.cos(rot) * offset;
      var y = this.y + Math.sin(rot) * offset;

      ctx.lineTo(x, y);
    }
    ctx.stroke();

  } else {

    ctx.globalAlpha = 0.1;
    ctx.fillRect(this.x - 8, this.y - 8, 16, 16);

    ctx.globalAlpha = 0.2;
    ctx.fillRect(this.x - 4, this.y, 8, 8);

    ctx.globalAlpha = 1.0;
    ctx.fillRect(this.x - 4, this.y - 4, 8, 8);
  }
  if (this.piercing && false)
    addGameObj(new TriTrail(this.x, this.y, size, 1.5 * this.lifeTime / GAME_CONST.BASE_BULLET_LIFETIME, rgbColor, dir));
  else
    addGameObj(new Trail(this.x - 3, this.y - 3, 6, 6, 0.5 * this.lifeTime / GAME_CONST.BASE_BULLET_LIFETIME, rgbColor));

  if (Math.random() > 0.9)
    addGameObj(new Spark(this.x, this.y, Math.random() * 0.015, rgbColor));

  if (isTutorialMode || roundResult) {
    for (var key in players) {
      var p = players[key];

      // if (p != myPlayer && (!this.ownerId || !p.id || p.id != this.ownerId)) {
      if (p != myPlayer && (!this.ownerId || !p.id || p.id != this.ownerId)) {
        var d = Math.sqrt((p.x - this.x) * (p.x - this.x) + (p.y - this.y) * (p.y - this.y));
        if (d < 20) {
          p.kill();
          delete players[key];

          var isReal = false;
          if (isTutorialMode && !players[2] && !players[3] && !players[4] && !players[5] && p.id < 6) {
            if (GAME_CONST.EXTRA_SFX)
              new Audio('/resources/die.wav').play();
            setTutorial(5);
            setTimeout(() => {

              if (!isTutorialMode)
                return;

              setTutorial(6);
              setTimeout(() => { myRingAlpha = 1; }, 3500);

              setTimeout(() => {

                if (!isTutorialMode)
                  return;

                setTutorial(7);

                var x = w * 0.4;
                var y = h * 0.4;
                while (dist(x, y, myPlayer.x, myPlayer.y) < 100) {
                  x += w * 0.1;
                  y += h * 0.1;
                }

                addGameObj(new Powerup(x, y, 1));
                powerupSparks(x, y, 1);

              }, 8000);

            }, 8000);

            playerDeath(p.x, p.y);

            myKills++;
            myRingAlpha = 1;
            // addFeedText("Range increases when you get a kill");

            isReal = true;
          }
          var b = new Body(p.x, p.y, isReal);
          b.alpha = 1.0;
          addGameObj(b);

          if (!this.piercing)
            this.kill();

          return;
        }
      }
    }
  }
}

var myKills = 0;
var myPowerup = 0;
var myRingAlpha = 1;

function Player(x, y) {
  this.glow = 1.0;
  this.x = x;
  this.y = y;

  this.toX = x;
  this.toY = y;

  this.fromX = x;
  this.fromY = y;
  this.speedMult = 1.0;

  this.startTime = 0;
  this.endTime = 0;
  this.faceingRight = true;
  this.aiMoveTime = Math.random() * 6000;
  this.trailTimer = 0;

  this.invisFieldAlpha = 1.0;
  if (theInvisField && !theInvisField.toKill && dist(x, y, theInvisField.x, theInvisField.y) <= theInvisField.drawSize)
    this.invisFieldAlpha = 0.0;
}

const USE_TEXT_TIMER = true;

Player.prototype.drawTutorialText = function (dTime, ctx) {
  var upperText = null;
  var lowerText = null;

  tutorialDelay += dTime;
  var drawUpperLeft = false;

  if (tutorialState == 0) {
    upperText = "This is you";
    lowerText = "Use left click to move";
  }
  else if (tutorialState == 1) {
    upperText = "Be the last player alive";
    lowerText = "Use right click or press q to shoot";
  }
  else if (tutorialState == 2) {
    upperText = "Conserve your ammo";
    lowerText = "You have limited bullets";
  }
  else if (tutorialState == 3) {
    drawUpperLeft = true;
    upperText = "Hide in the crowd of decoys";
    lowerText = "Only shoot when you’re sure where a real enemy is";
  }
  else if (tutorialState == 4) {
    drawUpperLeft = true;
    upperText = "Every 35 seconds, all real players will be highlighted along with 3 decoys";
    lowerText = "Objective: shoot all of the highlighted targets";
  }
  else if (tutorialState == 5) {
    drawUpperLeft = true;
    upperText = "3 highlighted targets will always be decoys.";
    lowerText = "But at least one is a real player.";
  }
  else if (tutorialState == 6) {
    drawUpperLeft = true;
    upperText = "In a game with more than one enemy,";
    lowerText = "Each kill will increase your gun range.";
  }
  else if (tutorialState == 7) {
    drawUpperLeft = true;
    upperText = "After a while, an invisibility powerup will spawn";
    lowerText = "Objective: Move onto it to pick it up";
  }
  else if (tutorialState == 8) {
    drawUpperLeft = true;
    upperText = "Press space or W to use the powerup";
    lowerText = "You can still move and shoot while invisible";
  }
  else if (tutorialState == 9) {
    drawUpperLeft = true;
    upperText = "Now you know everything you need to know";
    lowerText = "When you're done, move into the portal";
  }


  ctx.globalAlpha = 1;
  ctx.fillStyle = "red";

  ctx.font = "16px Arial";

  ctx.textAlign = drawUpperLeft ? "left" : "center";

  if (upperText && tutorialDelay > 2000) {
    if (!drawUpperLeft)
      ctx.fillText(upperText, this.x, this.y - 50);
    else
      ctx.fillText(upperText, 40, 30);
  }

  var lowerMax = upperText ? 4000 : 2000;
  if (lowerText && tutorialDelay > lowerMax) {
    if (!drawUpperLeft)
      ctx.fillText(lowerText, this.x, this.y + 50);
    else
      ctx.fillText(lowerText, 40, 60);
  }
}

function isHighThreat() {

  if (!threatIndex)
    return false;

  var knows = false;
  for (var key in threatIndex) {
    if (threatIndex[key] > 80 && key != myId && players[key] && !players[key].toKill)
      return true;
  }
}

function aiKnowsWhereAllEnemiesAre() {

  if (!threatIndex)
    return false;

  var numKnown = 0;
  for (var key in threatIndex) {
    if (!players[key] || players[key].toKill)
      delete threatIndex[key];
    else if (threatIndex[key] > 80 && key != myId)
      numKnown++;
  }

  var numPlayersToKnow = numPlayers - 1;
  if (timeNow < aiInvisWarning)
    numPlayersToKnow--;

  if (aiLevel > 1) {
    if (numKnown >= numPlayersToKnow) {
      for (var key in threatIndex) {
        if (threatIndex[key] < 80)
          threatIndex[key] = 0;
      }
    }
  }

  return numKnown >= numPlayersToKnow || timeNow < aiInvisWarning;
}

Player.prototype.isPowerupWorth = function (powerup, distToTarget) {

  var d = dist(this.x, this.y, powerup.x, powerup.y);
  if (this.isAiRevealed && d > 150 + distToTarget)
    return false;

  var high = isHighThreat();
  var canHide = this.isAiRevealed && !this.shield && this.speedMult <= 1.1;
  if (!powerup.type)
    return high || canHide;

  if ((powerup.type == 1 || powerup.type == 6 || powerup.type == 7) && (high || canHide)) // stealth powerups
    return true;
  if (powerup.type == 10 && canHide) // blackout
    return true;

  var powerTypes = [
    2, // shield
    3, // shotgun
    4, // level
    8, // speed
    9, // rapid fire
    11, // radar shots
    12, // poison
  ];

  for (var i = 0; i < powerTypes.length; i++)
    if (powerTypes[i] == powerup.type)
      return true;
}

Player.prototype.shouldUsePower = function (aiKnows) {
  if (myPowerup > 0) {

    var stealthTypes = [
      1, // invis
      6, // teleport
      7, // decoy
      10, // blackout
    ];

    for (var i = 0; i < stealthTypes.length; i++) {
      if (stealthTypes[i] == myPowerup) {

        if (aiKnows && this.target && dist(this.x, this.y, this.target.x, this.target.y) > 200)
          return false;

        if (this.isAiRevealed) {
          this.isAiRevealed = false;
          return true;
        }

        return false;
      }
    }

    return true;
  }
}

Player.prototype.drawDebugData = function (dTime, ctx) {

  if (debugData[this.id]) {

    if (debugData[this.id].target)
      this.target = players[debugData[this.id].target];

    if (this.target) {
      ctx.strokeStyle = "#FF0000";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(this.target.x, this.target.y);
      ctx.stroke();
    }

    if (debugData[this.id].isBotRevealed) {

      ctx.textAlign = "center";
      ctx.font = "12px Arial";
      ctx.globalAlpha = 1.0;
      ctx.fillStyle = "red";
      ctx.fillText("r: (" + debugData[this.id].threatIndex + ")", this.x, this.y + 20);

    } else if (debugData[this.id].threatIndex) {

      ctx.textAlign = "center";
      ctx.font = "12px Arial";
      ctx.globalAlpha = 1.0;
      ctx.fillStyle = "red";
      ctx.fillText(Math.floor(debugData[this.id].threatIndex), this.x, this.y + 20);
    }

    if (debugData[this.id].isBot) {

      var size2 = 18;
      ctx.lineWidth = 1;
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = "#FF0000";

      ctx.beginPath();
      ctx.rect(this.x - size2 / 2, this.y - size2 / 2, size2, size2);
      var size2 = 21;
      ctx.rect(this.x - size2 / 2, this.y - size2 / 2, size2, size2);
      ctx.stroke();

    }
  } else if (false) {

    ctx.textAlign = "center";
    ctx.font = "7px Arial";
    ctx.globalAlpha = 1.0;
    ctx.fillStyle = "red";
    if (this.id)
      ctx.fillText(Math.floor(this.id), this.x, this.y + 20);
    else
      ctx.fillText("error", this.x, this.y + 20);
  }
}


Player.prototype.updateAi = function (dTime, ctx) {

  if (blackoutAlpha > 0) {
    this.isAiRevealed = false;
    threatIndex = [];
    this.target = null;
  }

  var aiUsePower = false;
  var aiKnows = aiKnowsWhereAllEnemiesAre();
  if (this.shouldUsePower(aiKnows))
    aiUsePower = true;

  if (!isAiMode) {
    threatIndex = {};
    this.dodgeRight = Math.random() > 0.5;
  }
  isAiMode = true;

  if (this.target && (this.target.invis || this.target.toKill || this.target.invisFieldAlpha < 0.8 || threatIndex[this.target.id] <= 1))
    this.target = null;
  else if (this.target) {
    ctx.strokeStyle = "#FF0000";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(this.x, this.y);
    ctx.lineTo(this.target.x, this.target.y);
    ctx.stroke();
  }


  // solo threats are minimized
  var numThreats = 0;
  for (var key in threatIndex) {
    if (threatIndex[key] > 0 && key != myId && players[key] && !players[key].toKill)
      numThreats++;
  }

  var minThreat = 0;
  if (numThreats == 1)
    minThreat = 100;
  else if (numThreats == 2)
    minThreat = 50;
  else if (aiLevel > 2 && numThreats == 3)
    minThreat = 30;
  else if (aiLevel > 3 && numThreats == 4 && numPlayers > 2)
    minThreat = 30;

  if (numThreats > 1) {
    for (var key in threatIndex) {
      if (threatIndex[key] > 0) {
        if (numThreats > 3 && aiLevel < 4)
          threatIndex[key] -= 0.001 * dTime;
        else if (numThreats > 2 && aiLevel < 3)
          threatIndex[key] -= 0.001 * dTime;
        else if (numThreats > 1 && aiLevel < 2)
          threatIndex[key] -= 0.001 * dTime;
        else if (threatIndex[key] < minThreat) {
          threatIndex[key] = minThreat;
        }
      }
    }
  }

  if (!this.timeSinceLastMoved)
    this.timeSinceLastMoved = timeNow;

  // dodge Bullets
  if (aiLevel > 1) {
    if (timeNow > this.timeSinceLastMoved + 80 + (4 - aiLevel) * 80) {
      for (var key in players) {
        var p = players[key];
        if (key != myId && p.bullet && !p.bullet.toKill) {

          var b = p.bullet;

          var d = dist(this.x, this.y, b.x, b.y);
          
          if (d < 100) {

            moveToX = this.x + (this.x - b.x) * 50 / d;
            moveToY = this.y + (this.y - b.y) * 50 / d;

            gotMove = true;
            this.timeSinceLastMoved = timeNow;
            io.emit("move", { x: moveToX, y: moveToY });
            this.isAiRevealed = true;
            return;
          }
        }
      }
    }
  }

  if (timeNow > this.timeSinceLastMoved + 200 + 200 * Math.random() + (4 - aiLevel) * 100 * Math.random()) {

    if (lastRevealTime + 1000 < timeNow) {
      if (aiLevel == 1 && Math.random() > 0.998) {
        threatIndex = [];
      }
      if (aiLevel == 0 && Math.random() > 0.98) {
        threatIndex = [];
      }
    }

    var moveToX = this.x;
    var moveToY = this.y;
    var gotMove = false;

    // dodge bombs
    if (theBomb && !theBomb.toKill) {
      var d = dist(this.x, this.y, theBomb.x, theBomb.y);
      if (d < theBomb.size * 1.4) {
        moveToX = this.x + (this.x - theBomb.x) * theBomb.size * 1.5 / d;
        moveToY = this.y + (this.y - theBomb.y) * theBomb.size * 1.5 / d;

        var minX = theWalls ? theWalls.left : 0;
        if (moveToX < minX)
          moveToX = minX;
        var maxX = theWalls ? w - theWalls.right : w;
        if (moveToX > maxX)
          moveToX = maxX;

        var minY = theWalls ? theWalls.top : 0;
        if (moveToY < minY)
          moveToY = minY;
        var maxY = theWalls ? h - theWalls.bottom : h;
        if (moveToY > maxY)
          moveToY = maxY;

        moveToX += 50 - Math.random() * 100;
        moveToY += 50 - Math.random() * 100;

        d = dist(theBomb.x, theBomb.y, moveToX, moveToY);
        if (d < theBomb.size * 1.4) {

          moveToX = this.x < w / 2 ? w * 0.9 : w * 0.1;
          moveToY = this.y < h / 2 ? h * 0.9 : h * 0.1;

          moveToX += 50 - Math.random() * 100;
          moveToY += 50 - Math.random() * 100;
        }
        gotMove = true;

        this.timeSinceLastMoved = timeNow + 1000;
      }
    }

    // dodge mines
    if (mines) {

      for (var key in mines) {
        let mine = mines[key];

        let d = dist(this.x, this.y, mine.x, mine.y);

        if (d < mine.size * 1.75) {
          moveToX = this.x + (this.x - mine.x) * mine.size * 1.75 / d;
          moveToY = this.y + (this.y - mine.y) * mine.size * 1.75 / d;

          var minX = theWalls ? theWalls.left : 0;
          if (moveToX < minX)
            moveToX = minX;
          var maxX = theWalls ? w - theWalls.right : w;
          if (moveToX > maxX)
            moveToX = maxX;

          var minY = theWalls ? theWalls.top : 0;
          if (moveToY < minY)
            moveToY = minY;
          var maxY = theWalls ? h - theWalls.bottom : h;
          if (moveToY > maxY)
            moveToY = maxY;

          moveToX += 10 - Math.random() * 20;
          moveToY += 10 - Math.random() * 20;

          d = dist(mine.x, mine.y, moveToX, moveToY);
          if (d < mine.size * 1.5) {

            moveToX = this.x < w / 2 ? w * 0.9 : w * 0.1;
            moveToY = this.y < h / 2 ? h * 0.9 : h * 0.1;

            moveToX += 50 - Math.random() * 100;
            moveToY += 50 - Math.random() * 100;
          }
          gotMove = true;
          this.timeSinceLastMoved = timeNow + 500;
        }
      }
    }

    if ((this.shield || this.speedMult > 1.0) && !this.invis)
      this.isAiRevealed = true;

    var aiPowerup = thePowerup;
    if (aiPowerup && aiPowerup.toKill)
      aiPowerup = null;
    if (!aiPowerup && thePowerupWarn && !thePowerupWarn.toKill)
      aiPowerup = thePowerupWarn;

    // figure out strat
    var strat = 0; // 0 = hide in crowd, 1 = hide on edge, 2 = agro on threats, 3 = go for powerup, 4 = hide in invis field, -1 = run!
    if (!isHighThreat() && Math.random() > 0.9 && !this.target)
      strat = 1;

    var distToTarget = 0;
    if (this.target)
      distToTarget = dist(this.x, this.y, this.target.x, this.target.y);

    if (aiKnows)
      distToTarget = 1000;

    if (this.isAiRevealed) { // hide on the edge if revealed and go for invis fields if possible

      if (aiKnows) // if we know our enemies, attack!
        strat = 2;
      else
        strat = 1;

      if (theInvisField && !theInvisField.toKill && dist(this.x, this.y, theInvisField.x, theInvisField.y) < theInvisField.drawSize + 100 + distToTarget)
        strat = 4;
    }

    if (this.speedMult > 1.1) // we have speeeeed
      strat = 2;

    if (myBullets <= 3) { // running low on bullets
      if ((this.isAiRevealed && !aiKnows) || Math.random() > 0.8 || myBullets < 1)
        strat = -1;
    }

    if ((this.shield || this.rapidFire || this.invis) && myBullets > 2) // we have good powerups lets go hunting
      strat = 2;

    if (this.target && (this.target.shield || this.target.speedMult > 1.1) && (this.isAiRevealed || this.revealTimer > timeNow))
      strat = -1; // enemy target is strong.  Run!

    if (aiPowerup && this.isPowerupWorth(aiPowerup, distToTarget)) // go for powerups that are worth
      strat = 3;

    var randomChance = 0;
    if (aiLevel == 0)
      randomChance = 0.5;
    else if (aiLevel == 1)
      randomChance = 0.8;

    if (randomChance > 0 && Math.random() > randomChance)
      strat = Math.floor(Math.random() * 6) - 1;

    var runPoint = null;
    var runningFromStealth = false;
    if (aiInvisWarning > timeNow) {
      if (this.isAiRevealed || dist(this.x, this.y, aiAlertRunPoint.x, aiAlertRunPoint.y) < 200) {
        strat = -1;
        runningFromStealth = true;
        runPoint = aiAlertRunPoint;
      } else if (Math.random() > 0.8) {
        strat = 1;
      }
    }

    if (blackoutAlpha > 0.9)
      strat = 0;

    if (strat == -1) {

      if (!runPoint && this.target)
        runPoint = this.target;

      if (runPoint) {
        moveToX = runPoint.x < w / 2 ? w * 0.9 : w * 0.1;
        moveToY = runPoint.y < h / 2 ? h * 0.9 : h * 0.1;
        gotMove = true;

        moveToX += 100 - Math.random() * 200;
        moveToY += 100 - Math.random() * 200;
      } else {

        strat = 1;
      }
    }

    // go after enemies
    if (blackoutAlpha <= 0.5) {
      var bestDistToEnemy = 10000;
      var bestEnemy = 0;
      for (var key in players) {
        var p = players[key];

        if (p != this && !p.invis) {

          var inBounds = true;

          var threat = threatIndex[p.id];
          var myRange = (myKills + 1) * GAME_CONST.BASE_BULLET_LIFETIME / GAME_CONST.BULLET_SPEED;
          var d = dist(this.x, this.y, p.x, p.y);

          var minX = theWalls ? theWalls.left : 0;
          var maxX = w - (theWalls ? theWalls.right : 0);
          var minY = theWalls ? theWalls.top : 0;
          var maxY = h - (theWalls ? theWalls.bottom : 0);
          if (p.x >= minX && p.x <= maxX && p.y >= minY && p.y <= maxY) {

            var revealTimeDiff = 8 * 1000;
            if (aiLevel == 4)
              revealTimeDiff = 16 * 1000;

            if (!aiKnows && myBullets > 4 && (threat > 0 || lastRevealTime + revealTimeDiff < timeNow) && numThreats < numPlayers + 2) {
              if (this.isAiRevealed && threat > -1 && d < myRange && myBullets > 6 && Math.random() > 0.96) {

                threat += 10;

              } else if (this.isAiRevealed && threat > -1 && d < myRange &&
                (p.toX != p.x || p.toY != p.toY) && dist(this.x, this.y, p.toX, p.toY) < d) {

                threat += 10;
              }
            }

            if (threat > 0 && (!aiKnows || threat > 80)) {

              if (this.isAiRevealed || threat >= 100 || Math.random() + threat * 0.0005 > 1 || strat == 2) {

                d /= (threat + 10);

                if (d < bestDistToEnemy) {
                  bestDistToEnemy = d;
                  bestEnemy = p;
                }
              }
            }
          }
        }
      }
    }

    if (bestEnemy)
      this.target = bestEnemy;

    // attack enemies (strat 2)
    if (this.target && strat == 2 && !gotMove) {

      moveToX = bestEnemy.x - 100 + Math.random() * 200;
      moveToY = bestEnemy.y - 100 + Math.random() * 200;
      gotMove = true;
    }

    // Grab powerups (strat 3)
    if (!gotMove && myPowerup == 0 && aiPowerup && !aiPowerup.toKill && strat == 3) {

      if (thePowerup && (this.isAiRevealed || aiKnows || Math.random() > 0.95 || (thePowerup && !thePowerup.toKill && thePowerup.type > 1 && Math.random() > 0.95))) {

        moveToX = aiPowerup.x;
        moveToY = aiPowerup.y;
        gotMove = true;

      } else if (Math.random() > 0.85) {

        var d = dist(this.x, this.y, aiPowerup.x, aiPowerup.y);
        if (d > 100) {
          moveToX = aiPowerup.x + Math.random() * 150 - 75;
          moveToY = aiPowerup.y + Math.random() * 150 - 75;
        }
        gotMove = true;
      }
    }

    // strat 4 run into an invis field
    if (!gotMove && strat == 4 && theInvisField && !theInvisField.toKill && Math.random() > 0.95) {

      gotMove = true;

      moveToX = theInvisField.x + 20 - Math.random() * 40;
      moveToY = theInvisField.y + 20 - Math.random() * 40;
    }

    // strat 1 hide on the edge
    if (!gotMove && strat == 1 && (Math.random() > 0.9 || this.isAiRevealed)) {

      gotMove = true;
      moveToX = this.x > w / 2 ? w * 0.9 : w * 0.1;
      moveToY = this.y > h / 2 ? h * 0.9 : h * 0.1;

      moveToX += 100 - Math.random() * 200;
      moveToY += 100 - Math.random() * 200;
    }

    // strat 0 hide in the crowd
    if (!gotMove && strat == 0 && Math.random() > 0.97) {

      var c = 0;
      var avgX = 0;
      var avgY = 0;
      for (var key in players) {
        var p = players[key];
        if (!p.toKill) {
          avgX += p.x;
          avgY += p.y;
          c++;
        }
      }
      avgX /= c;
      avgY /= c;

      gotMove = true;
      moveToX = avgX + 50 - Math.random() * 100;
      moveToY = avgY + 50 - Math.random() * 100;
    }

    var moveRandom = !gotMove && Math.random() > 0.98 && (!this.isAiRevealed || aiKnows);
    if (roundResult)
      moveRandom = Math.random() > 0.4;

    if (moveRandom) {
      gotMove = true;
      moveToX = w * Math.random();
      moveToY = h * Math.random();
    }

    var d = dist(this.x, this.y, moveToX, moveToY);
    if (d > 5 && gotMove) {
      io.emit("move", { x: moveToX, y: moveToY });
    }

    if (this.timeSinceLastMoved < timeNow)
      this.timeSinceLastMoved = timeNow;
  }

  if (!this.timeLastShoot)
    this.timeLastShoot = timeNow;

  var shootTarget = this.target;
  if (runningFromStealth && Math.random() > 0.5)
    shootTarget = runPoint;

  if (shootTarget && !shootTarget.toKill && !shootTarget.invis && timeNow > this.timeLastShoot + 400 * (4 - aiLevel)) {

    d = dist(this.x, this.y, shootTarget.x, shootTarget.y);
    var myRange = (myKills + 1) * GAME_CONST.BASE_BULLET_LIFETIME / GAME_CONST.BULLET_SPEED;

    if (!this.isAiRevealed && shootTarget.id && threatIndex[shootTarget.id] < 110)
      myRange *= 0.5;

    if (aiLevel < 2) // dumb ais shoot outside their ranges
      myRange *= 1 + Math.random() * 2;

    var shootFromMove = true;
    if (shootTarget.endTime) {

      var target = shootTarget;

      var delta = (timeNow + 100 - target.startTime) / (target.endTime - target.startTime);
      if (delta > 1)
        delta = 1;

      var tx = target.fromX + (target.toX - target.fromX) * delta;
      var ty = target.fromY + (target.toY - target.fromY) * delta;

      d = dist(this.x, this.y, tx, ty);
      shootFromMove = d < myRange;
    }

    if (shootFromMove) {
      var fudge = 5 + (4 - aiLevel) * 14;
      if (runningFromStealth)
        fudge = 50;

      io.emit("shoot", { x: shootTarget.x - fudge + Math.random() * fudge * 2, y: shootTarget.y - fudge + Math.random() * fudge * 2 });
    }
    this.timeLastShoot = timeNow;
  }

  return aiUsePower;
}

Player.prototype.updateThreatIndex = function (dTime) {

  // need something here for blackout

  if (isAiMode && threatIndex) {

    if (this == myPlayer) {

      ctx.textAlign = "center";
      ctx.font = "12px Arial";
      ctx.globalAlpha = 1.0;
      ctx.fillStyle = "red";
      if (this.isAiRevealed)
        ctx.fillText("r:" + this.isAiRevealed, this.x, this.y + 20);

      return;
    }

    if (!threatIndex[this.id])
      threatIndex[this.id] = 0;
    else if (threatIndex[this.id] > 0) {

      if (lastRevealTime + 1000 > timeNow && lastRevealTime + 100 < timeNow && !this.revealTimer) {
        threatIndex[this.id] = 0;
        if (aiLevel > 2) {
          if (aiLevel > 3)
            threatIndex[this.id] = -1000;
          else
            threatIndex[this.id] = -5;
        }
      }

      ctx.textAlign = "center";
      ctx.font = "12px Arial";
      ctx.globalAlpha = 1.0;
      ctx.fillStyle = "red";
      ctx.fillText(Math.floor(threatIndex[this.id]), this.x, this.y + 20);

      if (aiLevel > 0) {
        // mines
        if (mines) {
          for (var key in mines) {
            var mine = mines[key];
            if (!mine.toKill && dist(this.x, this.y, mine.x, mine.y) < mine.drawSize)
              threatIndex[this.id] = 0;
          }
        }

        if (this.y < 0)
          threatIndex[this.id] = -25;

        var walls = theWalls;
        if (walls) {
          if (this.y < walls.top)
            threatIndex[this.id] = -25;
          if (this.y > h - walls.bottom)
            threatIndex[this.id] = -25;

          if (this.x < walls.left)
            threatIndex[this.id] = -25;
          if (this.x > w - walls.right)
            threatIndex[this.id] = -25;
        }

        // bombs
        if (theBomb && !theBomb.toKill && dist(this.x, this.y, theBomb.x, theBomb.y) < theBomb.drawSize) {
          threatIndex[this.id] = -25;
        }

        // scans
        if (theScan && !theScan.toKill && Math.abs(this.x - theScan.xNow) < theScan.sizeX / 2 && Math.abs(this.y - theScan.yNow) < theScan.sizeY / 2 && this.revealTimer < timeNow) {
          threatIndex[this.id] = -25;
        }

        // invis
        if (theInvisField && !theInvisField.toKill && dist(this.x, this.y, theInvisField.x, theInvisField.y) < theInvisField.drawSize) {
          threatIndex[this.id] = 0;
        }

        if (this.revealTimer + 4 * 1000 > timeNow || threatIndex[this.id]) {
          if (thePowerup && !thePowerup.toKill && dist(this.x, this.y, thePowerup.x, thePowerup.y) < 150)
            threatIndex[this.id] += 0.001 * dTime;

          var myRange = (myKills + 1) * GAME_CONST.BASE_BULLET_LIFETIME / GAME_CONST.BULLET_SPEED;
          if (myPlayer) {
            var d = dist(this.x, this.y, myPlayer.x, myPlayer.y);
            if (d < myRange * 1.5)
              threatIndex[this.id] += 0.00125 * dTime;
            if (d < myRange * 0.8)
              threatIndex[this.id] += 0.00125 * dTime;
          }
        }
      }
    }

    if ((this.shield || this.speedMult > 1.1 || this.rapidFire) && threatIndex[this.id] < 100)
      threatIndex[this.id] = 100;
  }
}

Player.prototype.updateTutorialMove = function (dTime) {

  if (isTutorialMode && this !== myPlayer) {
    if (thePortal && dist(this.x, this.y, thePortal.x, thePortal.y) < 15) {
      this.kill();
      return;
    }

    this.aiMoveTime += dTime * Math.random();
    if (this.aiMoveTime > 6000) {
      this.aiMoveTime = 0;
      this.aiMove(timeNow);
    }
  }
}

function HSVtoRGB(h, s, v) {
  var r, g, b, i, f, p, q, t;
  if (arguments.length === 1) {
    s = h.s, v = h.v, h = h.h;
  }
  i = Math.floor(h * 6);
  f = h * 6 - i;
  p = v * (1 - s);
  q = v * (1 - f * s);
  t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0: r = v, g = t, b = p; break;
    case 1: r = q, g = v, b = p; break;
    case 2: r = p, g = v, b = t; break;
    case 3: r = p, g = q, b = v; break;
    case 4: r = t, g = p, b = v; break;
    case 5: r = v, g = p, b = q; break;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
}

var winX = w / 2;
var winY = h / 2;
Player.prototype.update = function (dTime, ctx) {

  this.updateThreatIndex(dTime);
  this.updateTutorialMove(dTime);
  this.updateMove();
  // alternate shoot using q (on key pressed) instead of right click
  if (!previouslyPressedKeys[81] && currentlyPressedKeys[81] === true) {
    shoot(mouseX, mouseY);
  }

  if (roundResult || matchResult) {

    if (!this.revealTimer || timeNow > this.revealTimer) {
      var rot = this.id + (timeNow - gameStartTime) / (5 * 1000);
      var rad = h * 0.4 * Math.cos(rot * 2);
      if (roundResult)
        rad = 50;

      var x = winX + Math.cos(rot) * rad;
      var y = winY + Math.sin(rot) * rad;
      this.move(x, y);
    }
  }

  if (isTutorialMode && myPlayer === this)
    this.drawTutorialText(dTime, ctx);

  if (Math.abs(this.x - this.toX) > 1) {
    this.faceingRight = this.x < this.toX;
  }

  this.glow -= 0.001 * dTime;
  if (!theInvisField || theInvisField.toKill || dist(this.x, this.y, theInvisField.x, theInvisField.y) > theInvisField.drawSize) {
    this.invisFieldAlpha += 0.002 * dTime;
  } else {
    this.invisFieldAlpha -= 0.002 * dTime;
    if (Math.random() > 0.995) {
      var size = 12;
      addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 1, "0, 0, 255"));
    }
  }

  if (this.invisFieldAlpha > 1.0)
    this.invisFieldAlpha = 1.0;
  else {
    if (this.id == myId && this.invisFieldAlpha < 0.25) {
      this.invisFieldAlpha = 0.25;
      if (isAiMode) {
        myPlayer.isAiRevealed = false;
      }

    } else if (this.invisFieldAlpha < 0.0) {
      this.invisFieldAlpha = 0.0;
      if (isAiMode)
        threatIndex[this.id] = 0;
    }
  }


  if (this.invis)
    ctx.fillStyle = "#0000FF";
  else {
    if (this.poisoned)
      ctx.fillStyle = "rgb(0, 80, 0)";
    else if (DARK_MODE)
      ctx.fillStyle = "#FFFFFF";
    else {

      ctx.fillStyle = "#000000";
    }
  }


  // draw myself
  var size = 12;
  var size2 = 16;
  ctx.lineWidth = 1;

  // roundRect(ctx, this.x - size / 2, this.y - size / 2, size, size, 2, true, true);
  ctx.globalAlpha = this.invisFieldAlpha * 0.2;
  ctx.fillRect(this.x - size / 2, this.y - size / 2 + 2, size, size);
  ctx.globalAlpha = this.invisFieldAlpha;
  ctx.fillRect(this.x - size / 2, this.y - size / 2, size, size);
  // updateCells(this.x - size / 2, this.y - size / 2, size, size);

  if (this.glow > 0) {
    ctx.fillStyle = "white";
    ctx.globalAlpha = this.glow * 0.1 * this.invisFieldAlpha;
    ctx.fillRect(this.x - size / 2, this.y - size / 2, size, size);
    ctx.globalAlpha = this.invisFieldAlpha;
  }

  ctx.fillStyle = "#666666";
  ctx.fillRect(this.x + (this.faceingRight ? 2 : -2), this.y - 4, 2, 4);

  if (this.poisoned) {

    ctx.lineWidth = 2.5;
    ctx.strokeStyle = "rgb(100, 255, 100)";
    ctx.beginPath();
    ctx.rect(this.x - size / 2, this.y - size / 2, size, size);
    ctx.stroke();

    ctx.globalAlpha = this.invisFieldAlpha * (timeNow - this.poisoned) / GAME_CONST.POISON_TIME;
    ctx.fillStyle = "rgb(100, 255, 100)";
    ctx.fillRect(this.x - size / 2, this.y - size / 2, size, size);
  }

  if (this.shield && this.invisFieldAlpha > 0) {

    ctx.beginPath();
    ctx.lineWidth = 2.5;
    ctx.strokeStyle = "rgb(50, 255, 50)";
    ctx.arc(this.x, this.y, 24, 0, 2 * Math.PI);

    ctx.arc(this.x, this.y, 26, 0, 2 * Math.PI * (1.0 - (timeNow - this.shieldTimer) / GAME_CONST.SHIELD_TIME));

    ctx.stroke();
    ctx.lineWidth = 1;

    var size = 15;
    addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 0.6 * this.invisFieldAlpha, "100, 255, 100"));

  } else if (!this.invis && (this.x != this.toX || this.y != this.toY) && this.invisFieldAlpha > 0) {

    // spawn lots of trails (make trails)
    var size = 10;

    this.trailTimer += dTime;
    if (this.trailTimer > 200) {
      this.trailTimer -= 200;
      var trailColor = "0, 0, 0";
      if (this.poisoned)
        trailColor = "0, 255, 0";

      addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 1.0 * this.invisFieldAlpha, trailColor, true, 0.15));
    }

    if (this.poisoned) {

      size = 12;
      addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 0.35 * this.invisFieldAlpha, "0, 255, 0"));

    } else if (this.speedMult > 1) {
      size = 12;

      if (roundResult && false) { // rainbow shit

        if (!this.color) {
          this.color = {};
          this.color.r = 255 * Math.random();
          this.color.g = 255 * Math.random();
          this.color.b = 255 * Math.random();
          if (Math.random() > 0.33)
            this.color.r = 255;
          else if (Math.random() > 0.5)
            this.color.g = 255;
          else
            this.color.b = 255;

          this.colorTime = 0;
        }

        this.colorTime += dTime;
        if (this.colorTime > 250) {
          this.colorTime -= 250;

          this.color.r = 255 * Math.random();
          this.color.g = 255 * Math.random();
          this.color.b = 255 * Math.random();
          if (Math.random() > 0.33)
            this.color.r = 255;
          else if (Math.random() > 0.5)
            this.color.g = 255;
          else
            this.color.b = 255;
        }

        // addGameObj(new Bit(this.x, this.y, "255, 0, 0"));

        // addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 10.0 * this.invisFieldAlpha, this.color.r + "," + this.color.g + "," + this.color.b));
        addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 10.0 * this.invisFieldAlpha, "255, 0, 0"));

      } else
        addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 1.0 * this.invisFieldAlpha, "0, 255, 200"));

    } else if (this.revealTimer > timeNow && this.id != myId) {
      size = 12;
      addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 0.35 * this.invisFieldAlpha, "255, 0, 0"));
    } else
      addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 0.3 * this.invisFieldAlpha, "0, 0, 0"));

    size = 3;
    if (Math.random() > 0.9)
      addGameObj(new Trail(this.x - size / 2, this.y - size / 2, size, size, 1.0 * this.invisFieldAlpha, "0, 0, 0"));

  }

  if (debugData)
    this.drawDebugData(dTime, ctx);

  if (myId == this.id) {

    if (!isTutorialMode) {
      afkWarningTimer += dTime;

      if (afkWarningTimer > 30 * 1000) {

        ctx.globalAlpha = 1.0;
        ctx.fillStyle = "red";

        ctx.textAlign = "center";
        ctx.font = "14px Arial";
        ctx.fillText("Warning: you may be kicked for being AFK unless you move.", this.x, this.y - 20);
      }
    }

    // local ai hotkeys
    if (false) {
      var aiUsePower = false;
      if (isAiMode || currentlyPressedKeys[112] || currentlyPressedKeys[113] || currentlyPressedKeys[114] || currentlyPressedKeys[115] || currentlyPressedKeys[116]) {
        for (var i = 112; i < 117; i++)
          if (currentlyPressedKeys[i])
            aiLevel = i - 112;
        aiUsePower = this.updateAi(dTime, ctx);
      }
    }

    if ((currentlyPressedKeys[32] || currentlyPressedKeys[87] || aiUsePower) && myPowerup > 0) // space or w
    {
      if (isTutorialMode) {
        myPlayer.invisTimer = timeNow;
        myPlayer.invis = true;
        myPowerup = 0;
        invisFx({ x: myPlayer.x, y: myPlayer.y });

        if (GAME_CONST.EXTRA_SFX)
          new Audio('/resources/cloak.wav').play();
      }
      else
        io.emit('usepower', { x: mouseX, y: mouseY });
    }

    if (this.invis && isTutorialMode && timeNow > this.invisTimer + GAME_CONST.INVIS_TIME) {
      this.invis = false;
      setTutorial(9);
      setTimeout(() => {

        if (isTutorialMode)
          addGameObj(new Portal(w * 0.95, h * 0.95));
      }, 4000)
    }

    ctx.globalAlpha = this.invisFieldAlpha;
    if (this.invis) {
      ctx.beginPath();
      ctx.lineWidth = 2.5;
      ctx.strokeStyle = "#0000FF";
      ctx.arc(this.x, this.y, 24, 0, 2 * Math.PI * (timeNow - this.invisTimer) / (GAME_CONST.INVIS_TIME));

      ctx.stroke();
      ctx.lineWidth = 1;
    }
    else {
      if (DARK_MODE)
        ctx.strokeStyle = "#EEEEEE";
      else
        ctx.strokeStyle = "#000000";
    }

    ctx.beginPath();
    ctx.rect(this.x - size2 / 2, this.y - size2 / 2, size2, size2);
    ctx.stroke();

    if (true || tutorialState > 0) {
      myRingAlpha -= dTime * 0.0003;
      var myRange = (myKills + 1) * GAME_CONST.BASE_BULLET_LIFETIME / GAME_CONST.BULLET_SPEED;

      if (myRingAlpha > 0) {
        ctx.globalAlpha = myRingAlpha;
        ctx.beginPath();
        ctx.strokeStyle = "red";
        if (myRange > 0)
          ctx.arc(this.x, this.y, myRange, 0, 2 * Math.PI);
        ctx.stroke();
      }

      ctx.globalAlpha = this.invisFieldAlpha;
      ctx.beginPath();
      ctx.strokeStyle = "#FF0000";

      var dist2 = dist(this.x, this.y, mouseX, mouseY)
      var d = Math.min(myRange, dist2);

      var atan = -Math.atan2(this.x - mouseX, this.y - mouseY) - Math.PI * 0.5;
      var s = Math.min(Math.PI * 0.1, d > 0 ? Math.PI / (d * 0.25) : 0);
      if (d > 0)
        ctx.arc(this.x, this.y, d, atan - s, atan + s);

      ctx.stroke();

      var dx = mouseX - this.x;
      var dy = mouseY - this.y;
      if (dist2 > myRange) {
        dx *= myRange / dist2;
        dy *= myRange / dist2;
      }

      ctx.globalAlpha = this.invisFieldAlpha;
      ctx.fillStyle = "#FF0000";
      ctx.fillRect(this.x - 1.5 + dx, this.y - 1.5 + dy, 3, 3);
    }
  }
  else if (this.revealTimer > timeNow || (isTutorialMode && this.id < 6 && tutorialState >= 4)) {

    // addGameObj(new Box(this.x - size / 2, this.y - size / 2, size, size, 0.4));

    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.globalAlpha = this.invisFieldAlpha;
    ctx.strokeStyle = "#FF0000";
    ctx.rect(this.x - size2 / 2, this.y - size2 / 2, size2, size2);
    ctx.stroke();

    if (this.alpha > 0) {
      this.alpha -= dTime * 0.0001;
      if (this.alpha > 0) {
        ctx.fillStyle = "red";
        ctx.globalAlpha = this.alpha * 0.1;

        var size = 8;
        ctx.fillRect(this.x - 25, this.y - size / 2, 50, size);
        ctx.fillRect(this.x - size / 2, this.y - 25, size, 50);
      }
    }
  }

  // used for key pressed calculations
  previouslyPressedKeys = Object.assign({}, currentlyPressedKeys);
}

Player.prototype.updateMove = function () {

  if (this.endTime - this.startTime == 0) {

    this.x = this.toX;
    this.y = this.toY;
    return;
  }

  var dist = (timeNow - this.startTime) / (this.endTime - this.startTime);
  if (dist > 1)
    dist = 1;

  this.x = this.fromX + (this.toX - this.fromX) * dist;
  this.y = this.fromY + (this.toY - this.fromY) * dist;
}

Player.prototype.move = function (x, y) {

  this.startTime = timeNow;
  this.endTime = timeNow + Math.sqrt((this.x - x) * (this.x - x) + (this.y - y) * (this.y - y)) * GAME_CONST.PLAYER_SPEED / this.speedMult;

  this.fromX = this.x;
  this.fromY = this.y;

  this.toX = x;
  this.toY = y;

  if (tutorialDelay > 4000 && tutorialState == 0) {
    myBullets = 10;
    setTutorial(1);
  }
}

var setTutorial = function (val) {
  if (val > tutorialState) {
    tutorialState = val;
    tutorialDelay = 0;
  }
}

Player.prototype.aiMove = function (time) {

  var size = 550;
  var x = this.x + size / 2 - size * Math.random();
  if (x < 0)
    x += size;
  if (x > w)
    x -= size;

  var y = this.y + size / 2 - size * Math.random();
  if (y < 0)
    y += size;
  if (y > h)
    y -= size;

  if (Math.random() > 0.5) {
    var mini = 20;
    if (Math.random() > 0.5)
      x = this.x + mini / 2 - mini * Math.random();
    else
      y = this.y + mini / 2 - mini * Math.random();
  }

  while (y < 150)
    y += 150;
  while (y < 120)
    y = 120;

  if (thePortal && Math.random() > 0.75) {
    x = thePortal.x;
    y = thePortal.y;
  }

  this.move(x, y);
}

// used only in the tutorial
Player.prototype.shoot = function (x, y) {

  if (myBullets <= 0) {
    noBulletsAlpha = 1.0;
    return;
  }

  myBullets--;
  myBulletRegenTime = timeNow;

  var b = new Bullet(this.x, this.y, x, y, GAME_CONST.BASE_BULLET_LIFETIME * (1 + myKills));
  addGameObj(b);

  if (GAME_CONST.EXTRA_SFX)
    new Audio('/resources/shoot.wav').play();

  if (tutorialState == 1) {
    setTutorial(2);
    setTimeout(() => {
      if (!isTutorialMode)
        return;

      setTutorial(3);

      setTimeout(() => {

        if (!isTutorialMode)
          return;

        maxBullets = 10;
        myBullets = 10;
        for (var i = 0; i < 30; i++) {
          var thePlayer = new Player(w * Math.random(), (h - 80) * Math.random() + 80);

          for (var j = 0; j < 4; j++) {
            addGameObj(new Bit(thePlayer.x - 4 + 8 * Math.random(), thePlayer.y - 4 + 8 * Math.random(), "0, 0, 0", 0.25));
          }

          thePlayer.id = i + 2;
          players[i + 2] = thePlayer;
          addGameObj(thePlayer);
        }

      }, 2000)

      setTimeout(() => {

        if (!isTutorialMode)
          return;
        setTutorial(4);
        myBullets = 10;

      }, 8000)

    }, 6000)
  }
}

function addGameObj(newObj) {
  if (!newObj.kill)
    newObj.kill = function () { this.toKill = true; };
  gameObjects.push(newObj);
  newObj.gameObjIndex = gameObjects.length;
}

function kill(obj) {
  obj.toKill = true;
}

function removeFromArray(obj, ary) {

  var index = ary.indexOf(obj);
  if (index > -1)
    ary.splice(index, 1);
}

function Body(x, y, wasReal, poisoned) {
  this.x = x;
  this.y = y;
  this.wasReal = wasReal;
  this.poisoned = poisoned;
  this.alpha = 0;
}

Body.prototype.update = function (dTime, ctx) {

  ctx.globalAlpha = 1.0;
  if (DARK_MODE)
    ctx.strokeStyle = "#EEEEEE";
  else
    ctx.strokeStyle = "rgb(70, 70, 90)";

  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.rect(this.x - 3, this.y - 3, 6, 6);
  ctx.stroke();

  this.alpha -= 0.0005 * dTime;

  if (this.alpha > 0) {

    ctx.fillStyle = this.poisoned ? "rgb(100, 255, 100)" : "rgb(140, 140, 175)";
    ctx.globalAlpha = this.alpha;
    ctx.beginPath();
    ctx.rect(this.x - 6, this.y - 6, 12, 12);
    ctx.fill();
  }

  if (this.wasReal) {
    ctx.strokeStyle = this.poisoned ? "#00FF00" : "#FF0000";
    ctx.beginPath();

    ctx.moveTo(this.x - 20, this.y - 20);
    ctx.lineTo(this.x + 20, this.y + 20);

    ctx.moveTo(this.x + 20, this.y - 20);
    ctx.lineTo(this.x - 20, this.y + 20);
    ctx.stroke();
  }
}


function Fail(x, y, speed, color) {
  this.alpha = 1;
  this.x = x;
  this.y = y;
  this.speed = speed;
  this.color = color;
}

Fail.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.0001 * this.speed;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    ctx.strokeStyle = "rgba(" + this.color + ")";
    ctx.globalAlpha = this.alpha;

    ctx.lineWidth = 1.5;
    ctx.beginPath();

    var x = this.x;
    var y = this.y;

    ctx.moveTo(x, y);

    for (var i = 0; i < 5; i++) {
      x += (Math.random() - 0.5) * 25;
      y += (Math.random() - 0.5) * 25;
      ctx.lineTo(x, y);
    }

    ctx.stroke();
  }
}

function Boom(x, y, size = 20, fill = "#000000") {
  this.alpha = 1;
  this.x = x;
  this.y = y;
  this.size = size;
  this.fill = fill;
}

Boom.prototype.update = function (dTime, ctx) {
  this.alpha -= dTime * 0.001;
  if (this.alpha <= 0)
    kill(this);
  else {
    ctx.fillStyle = this.fill;
    ctx.globalAlpha = 1;
    ctx.strokeStyle = "rgba(255, 0, 0, 1)";
    ctx.lineWidth = 1;

    ctx.beginPath();
    if (this.size * this.alpha > 0)
      ctx.arc(this.x, this.y, this.size * this.alpha, 0, 2 * Math.PI);
    ctx.fill();
    ctx.stroke();
  }
}

function Ring(x, y, alphaChange, color, size = 50) {
  this.alpha = alphaChange < 0 ? 0 : 1;
  this.x = x;
  this.y = y;
  this.alphaChange = alphaChange;

  this.color = color;
  this.rot = Math.random() * 2 * Math.PI;
  this.size = 50;
}

Ring.prototype.update = function (dTime, ctx) {
  this.alpha -= dTime * this.alphaChange * 0.001;
  if ((this.alphaChange > 0 && this.alpha <= 0.001) || (this.alphaChange <= 0 && this.alpha >= 1))
    kill(this);
  else {
    ctx.globalAlpha = this.alpha * 0.2;
    ctx.fillStyle = "rgb(" + this.color + ")";
    ctx.strokeStyle = "rgb(" + this.color + ")";
    ctx.lineWidth = 1;

    ctx.beginPath();
    if (this.size * (1 - this.alpha) > 0)
      ctx.arc(this.x, this.y, this.size * (1 - this.alpha), 0, 2 * Math.PI);
    ctx.fill();

    ctx.globalAlpha = this.alpha * 0.45;
    this.rot += Math.PI * 0.00025 * dTime;
    ctx.beginPath();
    if (this.size * (1 - this.alpha) > 0)
      ctx.arc(this.x, this.y, this.size * (1 - this.alpha), this.rot, Math.PI * 0.3 + this.rot);
    ctx.stroke();
    // ctx.stroke();
  }
}

function Point(x, y, color, alpha, alphaChange) {
  this.alpha = alpha;
  this.alphaChange = alphaChange;
  this.x = x;
  this.y = y;
  this.color = color;

  var rot = Math.random() * Math.PI * 2;
  var mult = 0.025;
  this.dx = Math.cos(rot) * mult;
  this.dy = Math.sin(rot) * mult;
}

Point.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * this.alphaChange;
  if (this.alpha <= 0)
    kill(this);
  else {
    this.x += this.dx * dTime;
    this.y += this.dy * dTime;

    ctx.globalAlpha = this.alpha;
    ctx.fillStyle = "rgb(" + this.color + ")";
    ctx.fillRect(this.x, this.y, 1.5, 1.5);
  }
}

function Line(x, y, x2, y2, color, alpha, alphaChange) {
  this.alpha = alpha;
  this.alphaMult = 1;
  this.alphaChange = alphaChange;
  this.x = x;
  this.y = y;
  this.x2 = x2;
  this.y2 = y2;
  this.color = color;
  this.dx = 0;
  this.dy = 0;
  this.lineWidth = 1;

}
Line.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * this.alphaChange;
  if (this.alpha <= 0)
    kill(this);
  else {

    this.x += this.dx * dTime;
    this.x2 += this.dx * dTime;
    this.y += this.dy * dTime;
    this.y2 += this.dy * dTime;

    this.alphaMult += dTime * 0.00025;
    ctx.globalAlpha = this.alpha * Math.min(1, this.alphaMult) * 0.05;
    ctx.strokeStyle = "rgb(" + this.color + ")";
    ctx.lineWidth = this.lineWidth * 10;
    ctx.beginPath();

    if (this.useDepth) {

      var mult = this.alphaMult * 0.5 + 0.5;
      var alt = 1 - mult;
      ctx.moveTo(this.x * mult + w * alt / 2, this.y * mult + h * alt / 2);
      ctx.lineTo(this.x2 * mult + w * alt / 2, this.y2 * mult + h * alt / 2);
    } else {
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(this.x2, this.y2);
    }

    ctx.stroke();

    ctx.globalAlpha = this.alpha * Math.min(1, this.alphaMult);
    ctx.lineWidth = this.lineWidth;
    ctx.stroke();
  }
}

function Bit(x, y, color, alpha = 1) {
  this.alpha = alpha;
  this.x = x;
  this.y = y;
  this.color = color;
  this.startMove = Math.floor(Math.random() * 4);
  this.move = this.startMove;
  this.timer = 0;
  this.moveMult = Math.random();
  this.px = x;
  this.py = y;
  this.preserve = true;
}

Bit.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.00025;
  if (this.alpha <= 0)
    kill(this);
  else {

    this.timer += dTime;

    if (this.timer > 200) {
      var pMove = this.move;

      this.timer -= 400 * Math.random();
      this.move = this.startMove;
      if (Math.random() > 0.66) {
        this.move += Math.random() > 0.5 ? 1 : -1;
        if (this.move > 3)
          this.move = 0;
        if (this.move < 0)
          this.move = 3;
      }

      if (this.move != pMove || true) {
        addGameObj(new Line(this.x, this.y, this.px, this.py, this.color, this.alpha, 0.0025));
        this.px = this.x;
        this.py = this.y;
      }
    }
    var moveAmt = dTime * 0.1;
    if (this.move == 0)
      this.x += moveAmt;
    else if (this.move == 1)
      this.y += moveAmt;
    else if (this.move == 2)
      this.x -= moveAmt;
    else if (this.move == 3)
      this.y -= moveAmt;

    ctx.globalAlpha = this.alpha;
    ctx.strokeStyle = "rgb(" + this.color + ")";
    ctx.lineWidth = 1.0;
    ctx.beginPath();
    ctx.moveTo(this.px, this.py);
    ctx.lineTo(this.x, this.y);
    ctx.stroke();
  }
}

function Spark(x, y, speed, color) {
  this.alpha = 1;
  this.x = x;
  this.y = y;
  this.timeAlive = 0;
  this.color = color;
  this.alphaMult = Math.random();

  this.rot = Math.random() * Math.PI * 2;

  speed *= 0.1;
  this.speed = speed;
  this.timer = 0;
}

Spark.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.00015;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    this.timeAlive += dTime;
    var d = this.speed * this.timeAlive;

    ctx.lineWidth = 1;

    var s = "rgb(" + this.color + ")";
    ctx.fillStyle = s;
    ctx.strokeStyle = s;


    ctx.globalAlpha = this.alpha * this.alphaMult;
    ctx.moveTo(this.x, this.y);
    ctx.beginPath();

    this.timer += dTime;

    var px = this.x;
    var py = this.y;

    for (var i = 0; i < 5; i++) {
      var rot = this.rot + this.speed * this.timeAlive * 0.02 + i * 0.25;

      var x = this.x + Math.cos(rot) * d * (i + 1) / 5;
      var y = this.y + Math.sin(rot) * d * (i + 1) / 5;

      ctx.lineTo(x, y);

      if (this.timer > 400 && Math.random() > 0.93 && dist(x, y, px, py) > 5) {
        this.timer -= 400;
        addGameObj(new Line(x, y, this.x, this.y, this.color, this.alpha * this.alphaMult, 0.001));
      }
      ctx.fillRect(x, y, 1, 1);

      px = x;
      py = y;
    }
    ctx.stroke();


    return;
    ctx.globalAlpha = this.alpha * this.alphaMult * 0.1;
    ctx.lineWidth = 10;
    ctx.stroke();

    /*
    ctx.strokeStyle = "black";
    ctx.beginPath();
    ctx.rect(this.x, this.y, 4, 4);
    ctx.stroke();
    */
  }
}

function Reveal(x, y, w, h) {
  this.alpha = 1;

  this.x = x;
  this.y = y;
  this.w = w;
  this.h = h;
}

Reveal.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.0001;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    ctx.beginPath();
    ctx.globalAlpha = this.alpha;
    ctx.strokeStyle = "red";
    ctx.rect(this.x, this.y, this.w, this.h);
    ctx.stroke();
  }
}

function Reveal(x, y, w, h) {
  this.alpha = 1;

  this.x = x;
  this.y = y;
  this.w = w;
  this.h = h;
}

Reveal.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.0001;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    ctx.beginPath();
    ctx.globalAlpha = this.alpha;
    ctx.strokeStyle = "red";
    ctx.rect(this.x, this.y, this.w, this.h);
    ctx.stroke();
  }
}

function Box(x, y, w, h, a, drawOutline) {
  this.alpha = a;

  this.x = x;
  this.y = y;
  this.w = w;
  this.h = h;
  this.drawOutline = drawOutline;
  this.preserve = true;
}

Box.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.005;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.fillStyle = "red";
    ctx.strokeStyle = "red";

    ctx.globalAlpha = this.drawOutline ? this.alpha * 0.1 : this.alpha * 0.002;
    ctx.fillRect(this.x, this.y, this.w, this.h);

    ctx.globalAlpha = this.drawOutline ? this.alpha : this.alpha * 0.05;
    ctx.rect(this.x, this.y, this.w, this.h);
    ctx.stroke();
  }
}

function Trail(x, y, w, h, a, color, outline = false, alphaMult = 0.1) {
  this.alpha = a;

  this.x = x;
  this.y = y;
  this.w = w;
  this.h = h;
  this.color = color;
  this.outline = outline;
  this.alphaMult = alphaMult;
}

Trail.prototype.update = function (dTime, ctx) { }
Trail.prototype.underUpdate = function (dTime, ctx) {

  this.alpha -= dTime * 0.001;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    ctx.globalAlpha = Math.min(this.alpha, 1.0) * this.alphaMult;

    if (this.outline) {
      ctx.strokeStyle = "rgb(" + this.color + ")";
      ctx.beginPath();
      ctx.rect(this.x, this.y, this.w, this.h);
      ctx.stroke();

    } else {

      ctx.fillStyle = "rgb(" + this.color + ")";
      ctx.fillRect(this.x, this.y, this.w, this.h);
    }
  }
}

function RadarPulse(x, y, s, color) {

  this.x = x;
  this.y = y;
  this.size = s;
  this.alpha = 1;
  this.color = color;
}

RadarPulse.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.0015;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    ctx.globalAlpha = this.alpha;
    ctx.strokeStyle = this.color;
    ctx.fillStyle = this.color;
    ctx.lineWidth = 1;

    ctx.beginPath();
    const rad = (2.0 - this.alpha) * 0.5 * this.size * 1.25;
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.globalAlpha = this.alpha * 0.01;
    ctx.fill();
  }
}


function PoisonPulse(x, y, s, color) {

  this.x = x;
  this.y = y;
  this.size = s;
  this.alpha = 1;
  this.color = color;
}

PoisonPulse.prototype.update = function (dTime, ctx) {

  this.alpha -= dTime * 0.00075;
  if (this.alpha <= 0) {
    kill(this);
  }
  else {
    ctx.globalAlpha = this.alpha * 0.5;
    ctx.strokeStyle = this.color;
    ctx.fillStyle = this.color;
    ctx.lineWidth = 1;

    ctx.beginPath();
    const rad = (2.0 - this.alpha) * 0.5 * this.size * 1.25;
    if (rad > 0)
      ctx.arc(this.x, this.y, rad, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.globalAlpha = this.alpha * 0.0051;
    ctx.fill();


    ctx.globalAlpha = this.alpha * 0.1;
    ctx.lineWidth = 4;

    var doneMove = false;
    var origX = this.x;
    var origY = this.y;

    var size = this.size;
    for (var rot = 0; rot <= Math.PI * 2; rot += Math.PI / 60) {
      var shudderX = 4 - 8 * Math.random();
      var shudderY = 4 - 8 * Math.random();
      var x = this.x + Math.cos(rot) * size + shudderX;
      var y = this.y + Math.sin(rot) * size + shudderY;

      if (!doneMove) {
        origX = x;
        origY = y;
        doneMove = true;
        ctx.moveTo(x, y);
        ctx.beginPath();
      } else
        ctx.lineTo(x, y);
    }

    ctx.lineTo(origX, origY);
    ctx.stroke();
  }
}

function Text(x, y, text, text2, color) {

  this.x = x;
  this.y = y;
  this.text = text;
  this.text2 = text2;

  this.color = color;
  this.alpha = 2.0;
}

Text.prototype.update = function (dTime, ctx) { }
Text.prototype.overUpdate = function (dTime, ctx) {
  this.alpha -= 0.0005 * dTime;
  if (this.alpha <= 0) {
    this.kill();
  } else {

    ctx.globalAlpha = Math.min(1.0, this.alpha);
    ctx.fillStyle = "rgb(" + this.color + ")";

    ctx.textAlign = "center";
    ctx.font = "14px Arial";
    ctx.fillText(this.text, this.x, this.y);
    ctx.fillText(this.text2, this.x, this.y + 16);
  }
}

var thePortal = null;
function Portal(x, y) {

  this.x = x;
  this.y = y;
  thePortal = this;
  this.leaving = false;
  this.alpha = 0;
}

Portal.prototype.update = function (dTime, ctx) {

}

Portal.prototype.overUpdate = function (dTime, ctx) {

  var r = Math.floor(Math.random() * 255);
  var b = Math.floor(Math.random() * 255);
  if (Math.random() > 0.5)
    r = 255;
  else
    b = 255;

  var color = "" + r + ",0," + b + "";

  if (Math.random() > 0.9)
    addGameObj(new Spark(this.x, this.y, Math.random() * 0.2, "255, 0, 255"));
  if (Math.random() > 0.9)
    addGameObj(new Bit(this.x, this.y, "255, 0, 255"));
  if (Math.random() > 0.975)
    addGameObj(new Ring(this.x, this.y, -Math.random() * Math.random() * 1.5 - 0.2, color));
  if (Math.random() > 0.975)
    addGameObj(new Ring(this.x, this.y, 0.2 + Math.random(), color));

  if (Math.random() > 0.97)
    addGameObj(new Fail(this.x, this.y, 8, color));
  if (Math.random() > 0.98) {
    var s = Math.random() * 30 + Math.random() * 20;
    var x = this.x - s / 2 + Math.random() * s;
    var y = this.y - s / 2 + Math.random() * s;
    addGameObj(new Box(x - s / 2, y - s / 2, s, s, 5 * Math.random(), true));
  }


  ctx.fillStyle = "rgb(" + color + ")";
  ctx.globalAlpha = 1;
  ctx.strokeStyle = "rgba(255, 0, 0, 1)";
  ctx.lineWidth = 1;

  ctx.beginPath();
  ctx.arc(this.x, this.y, 10, 0, 2 * Math.PI);
  ctx.fill();
  ctx.stroke();


  if (dist(this.x, this.y, myPlayer.x, myPlayer.y) < 20 || this.leaving) {
    this.leaving = true;
    this.alpha += 0.0015 * dTime;

    ctx.globalAlpha = this.alpha * 0.4;
    ctx.lineWidth = 2;
    ctx.fillStyle = "rgba(255, 255, 255, 1)";
    ctx.strokeStyle = "rgba(255, 0, 0, 1)";

    ctx.beginPath();
    if (this.alpha > 0)
      ctx.arc(this.x, this.y, 300 * this.alpha, 0, 2 * Math.PI);
    ctx.fill();
    ctx.stroke();

    if (this.alpha > 3) {
      incrementCounterValue("did_finish_tutorial", "yes");
      endGame();
      mainMenuFunction();

    }
  }
}

function addFeedText(text, largeText, color = "red", backColor = "white") {
  textBuffer.length = 0;
  textBuffer.push({ text: text, alpha: 1, largeText: largeText, color: color, backColor: backColor });
}

var textBuffer = [];

function updateTextBuffer(dTime) {

  ctx.font = "16px Arial";
  ctx.textAlign = "center";

  for (var i = 0; i < textBuffer.length; i++) {
    textBuffer[i].alpha -= dTime * 0.0001;
    if (textBuffer[i].alpha < 0)
      removeFromArray(textBuffer[i], textBuffer);
    else {

      if (textBuffer[i].largeText) {

        ctx.globalAlpha = textBuffer[i].alpha * 0.4;
        ctx.strokeStyle = textBuffer[i].color;
        ctx.lineWidth = 1;
        ctx.fillStyle = textBuffer[i].backColor;
        ctx.fillRect(0, i * 20 + 40, canvas.width, 80);
        ctx.beginPath();

        // ctx.rect(0, i * 20 + 40, canvas.width, 80);
        ctx.stroke();
      }

      ctx.globalAlpha = textBuffer[i].alpha;
      ctx.fillStyle = textBuffer[i].color;
      ctx.fillText(textBuffer[i].text, canvas.width / 2, i * 20 + 100);

      if (textBuffer[i].largeText) {
        ctx.font = "32px Arial";
        ctx.fillText(textBuffer[i].largeText, canvas.width / 2, 85);
      }
    }
  }
}

function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
  if (typeof stroke == 'undefined') {
    stroke = true;
  }
  if (typeof radius === 'undefined') {
    radius = 5;
  }
  if (typeof radius === 'number') {
    radius = { tl: radius, tr: radius, br: radius, bl: radius };
  } else {
    var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
    for (var side in defaultRadius) {
      radius[side] = radius[side] || defaultRadius[side];
    }
  }
  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();
  if (fill) {
    ctx.fill();
  }
  if (stroke) {
    ctx.stroke();
  }

}
